/*
	Cross-browser hasOwnProperty solution, based on answers from:
	http://stackoverflow.com/questions/135448/how-do-i-check-to-see-if-an-object-has-an-attribute-in-javascript
*/
/*
if ( !Object.prototype.hasOwnProperty ) {
    Object.prototype.hasOwnProperty = function(prop) {
            var proto = obj.__proto__ || obj.constructor.prototype;
            return (prop in this) && (!(prop in proto) || proto[prop] !== this[prop]);
    };
} //if

*/

/**
 * Root namespace for tag manaager
 * @namespace OBOXADS 
 */
var OBOXADS = OBOXADS || {};

/**
 * @namespace OBOXADS.fn
 */
OBOXADS.fn =  OBOXADS.fn || {};

(function (w,d) {
//    var oboxStartTime = new Date().getTime();


/**
 * @namespace OBOXADS.vars
 */

/**
 * Contains all configurations and states of the tag manager
 */
OBOXADS.vars = {
    /**
     * base URL of scripts
     * @alias OBOXADS.vars.baseURL
     * @type {string}
     */
    "baseURL": "//cdn.oboxads.com/v3",

    /**
     * Id of network
     * @alias OBOXADS.vars.netId
     * @type {string}
     */
    "netId": "139271940",

    /**
     * holds GET parameters for current page
     * @alias OBOXADS.vars.urlParams
     * @type {Object}
     */
    "urlParams": {},

    /**
     * current page language
     * @alias OBOXADS.vars.lang
     * @type {string}
     */
    "lang": 'fr',

    /**
     * user's age
     * @alias OBOXADS.vars.age
     * @type {number}
     */
    "age": 0,

    /**
     * user's age group e.g. 18-24
     * @alias OBOXADS.vars.ageGroup
     * @type {string}
     */
    "ageGroup": '',

    /**
     * user's gender
     * @alias OBOXADS.vars.gender
     * @type {string}
     */
    "gender": '',

    /**
     * user's gender
     * @alias OBOXADS.vars.gender
     * @type {string}
     */
    "affiliateId": '',

    /**
     * unique id of current page
     * @alias OBOXADS.vars.uniqueId
     * @type {string}
     */
    "uniqueId": '',

    /**
     * type of content
     * @alias OBOXADS.vars.contentType
     * @type {string}
     */
    "contentType": '',

    /**
     * list of keywords
     * @alias OBOXADS.vars.keywords
     * @type {string[]}
     */
    "keywords": [],

    /**
     * list of content category for the content
     * @alias OBOXADS.vars.contentCategories
     * @type {object}
     */
    "contentCategories": {},

    /**
     * group of content that pages belongs to
     * @alias OBOXADS.vars.contentGroup
     * @type {string}
     */
    "contentGroup": '',

    /**
     * holds tag information for each tag on the page
     * @alias OBOXADS.vars.tags
     * @type {Object}
     */
    "tags": {},

    /**
     * root ad unit 
     * @alias OBOXADS.vars.site
     * @type {string}
     */
    "site": "hollywoodpq>fr",

    /**
     * defines the section of the site user is currently on
     * @alias OBOXADS.vars.adUnit
     * @type {string}
     */
    "adUnit": '',

    /**
     * defines the section of the site user is currently on
     * @alias OBOXADS.vars.subAdUnit
     * @type {string}
     */
    "subAdUnit": '',

    /**
     * random number, will be the same for a single page view
     * @alias OBOXADS.vars.random
     * @type {number}
     */
    "random": Math.round(Math.random() * 1000000000),

    /**
     * unique id that identifies a piece of content
     * @alias OBOXADS.vars.postId
     * @deprecated use uniqueId instead
     */
    "postId": '',

    /**
     * reffering website (extract domain part of document.referrer
     * @alias OBOXADS.vars.referrer
     * @type {string}
     * @deprecated
     */
    "referrer": ("" + d.referrer.split("/").slice(2).shift()),

    /**
     * holds a count of each section
     * @alias OBOXADS.vars.sectionPosition
     * @type {Object.<number>}
     */
    "sectionPosition": {},

    /**
     * custom code to execute on a section
     * keys should be section or section-position
     *
     * @alias OBOXADS.vars.customFunctions
     * @type {object}
     */
    "customFunctions": {},

    /**
     * parameters for ad slots
     * @alias OBOXADS.vars.slotSettings
     * @type {object}
     */
    "slotSettings": {},

    /**
     * banners to load together to acheive combos
     * @alias OBOXADS.vars.groupLoad
     * @type {object}
     * @deprecated
     */
    "groupLoad": {
        "header-1": ['side-1'],
        "side-1": ['header-1']
    },

    /**
     * holds viewport's width and height
     * @alias OBOXADS.vars.viewportSize
     * @type {object}
     */
    "viewportSize": { "width": 0, "height": 0},

    /**
     * flag if the site is in mobile version or not
     * @alias OBOXADS.vars.mobile
     * @type {boolean}
     */
    "mobile": false,

    /**
     * type of tags to be used possible values are js, iframe and fif
     * @alias OBOXADS.vars.deliveryType
     * @type {string}
     */
    "deliveryType": 'js',

    /**
     * if FIF is used this should contain the url of the stub file
     * @alias OBOXADS.vars.stubURL
     * @type {string}
     */
    "stubURL": "/oboxads-stubs/adtech.html",

    /**
     * flags to help in certain products
     * initialize to null
     * if value is null will flag unset
     * if value is true or false it has been manually set
     * @alias OBOXADS.vars.deliveryFlags
     * @type {object}
     */
    "deliveryFlags": {
        "pointOfEntry": null,
        "showOffer": null,
    },

    /**
     * flag if the site is responsive or not
     * @alias OBOXADS.vars.responsive
     * @type {boolean}
     */
    "responsive": true,

    /**
     * flag if the site is responsive or not
     * @alias OBOXADS.vars.viewableAds
     * @type {boolean}
     */
    "viewableAds": false,

    /**
     * flag if ads are to be displayed
     * @alias OBOXADS.vars.showAds
     * @type {boolean}
     */
    "showAds": true,

    /**
     *flag if debug mode is activated
     * @alias OBOXADS.vars.debug
     * @type {boolean}
     */
    "debug": false,

    /**
     * Setup different ad mode to allow 
     * different behavior in different modes
     * @alias OBOXADS.vars.adMode
     * @type {string}
     */
    "adMode": "",

    /**
     * flag if lib is ready or not
     * cannot be changed with config command
     * @alias OBOXADS.vars.ready
     * @type {boolean}
     */
    "ready": false,

    /**
     * Time when the tag man was initiaed
     *
     * @alias OBOXADS.vars.startTime
     * @type {integer}
     */
    "startTime": -1,

    /**
     * counts the number of pageviews viewed in one session
     * @alias OBOXADS.vars.sessionDepth
     * @type {number}
     */
    "sessionDepth" : 1,

    /**
     * counts the number of banner viewed in one day
     * @alias OBOXADS.vars.dailyBannerView
     * @type {number}
     */
    "dailyBannerView" : 0,

    /**
     * utm_campaign that was set at begining of users's session
     * @alias OBOXADS.vars.utmCampaign
     * @type {string}
     */
    "utmCampaign" : '',

    /**
     * utm_source that was set at begining of users's session
     * @alias OBOXADS.vars.utmSource
     * @type {string}
     */
    "utmSource" : '',

    /**
     * utm_medium that was set at begining of users's session
     * @alias OBOXADS.vars.utmMedium
     * @type {string}
     */
    "utmMedium" : '',

    /**
     * utm_content that was set at begining of users's session
     * @alias OBOXADS.vars.utmContent
     * @type {string}
     */
    "utmContent" : '',

    /**
     * utm_term that was set at begining of users's session
     * @alias OBOXADS.vars.utmTerm
     * @type {string}
     */
    "utmTerm" : '',

    /**
     * vars used by addons
     * @alias OBOXADS.vars.addons
     * @type {object}
     */
    "addons" : {}
};

    var slots = {}, slotSettings = {}, 
        //bannerTimmings = {}, addBannerTimmings = {},
        prebidActive = false,
        waitingForResources = 0,
        desktopSize = [1024,491],
        tabletSize = [780, 490],
        mobileSize = [0,0],
        eventListeners = {},
        eventsLog = {},
        allScripts = d.getElementsByTagName('script');

/**
 * @namespace localFunctions
 */

/**
 * @memberof localFunctions
 */
var log = function () {
    OBOXADSQ.push({
        "cmd": "log",
        "arguments": arguments
    });
}; //log

/**
 * parse all query stirng parameters 
 * and store them in OBOXADS.vars.urlParams 
 *
 * @memberof localFunctions
 */
var parseURLParams = function () {
    var i, pairs, parts,
        urlParams = {},
        queryString = location.href.split("?");
    

    if (queryString.length > 1) {
        pairs = queryString[1].split("&");

        for (i = pairs.length-1; i >= 0; i--) {
            parts = pairs[i].split("=");
            urlParams[parts[0]] = parts[1];
        }
        OBOXADS.vars.urlParams = urlParams;
    }

};

/**
 * detect debug mode from urlParams or cookies and init debugging 
 * @memberof localFunctions
 */
var setupDebugMode = function () {
  let debugMode = false;

    if ( OBOXADS.vars.urlParams.hasOwnProperty('debug') ) { 
      debugMode = OBOXADS.vars.urlParams.debug !== 'false' ? OBOXADS.vars.urlParams.debug : false;
      OBOXADS.fn.addCookie('oboxads-debug', debugMode || "");
    } else {
      debugMode = OBOXADS.fn.readCookie('oboxads-debug') || false;
    } //if

    // check if debug mode if so load debug file
    if (debugMode !== false) {

      const cacheBust = new Date().getTime();

      switch (debugMode) {
        case 'info':
        case 'audit':
          OBOXADS.fn.loadScript(`${OBOXADS.vars.baseURL}/addons/debug/${debugMode}.js?cb=${cacheBust}`);
          break;
      }

      //OBOXADS.fn.loadScript(`${OBOXADS.vars.baseURL}/addons/debug/debug.js?cb=${cacheBust}`);

      //use console for logging
      log = function() {
        let args =  arguments.arguments || arguments;
        console.log.apply(console, args);
      }.bind(null, 'OBOXADS');
      OBOXADS.vars.debug = debugMode;
    } else {

        // only log in debug mode
        log = function() {};
    } //if

    OBOXADS.fn.log = log; // update reference
};

/**
 * detect viewport size
 * @memberof localFunctions
 */
var detectViewportSize = function() {
    // source: http://andylangton.co.uk/articles/javascript/get-viewport-size-javascript/
    var e = d.documentElement,
        g = d.getElementsByTagName('body')[0] || {};
    OBOXADS.vars.viewportSize.width = w.innerWidth || e.clientWidth || g.clientWidth || 0;
    OBOXADS.vars.viewportSize.height = w.innerHeight|| e.clientHeight|| g.clientHeight || 0;
};

/**
 * @memberof localFunctions
 */
var detectMobile = function() {
// alternate solution from : http://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
    var isMobile = false,
        viewportWidth = OBOXADS.vars.viewportSize.width;
    isMobile = (viewportWidth > 0 && viewportWidth < 728 ? true : false);
    
    // resolution is not mobile, backup check using user agent
    if (!isMobile) { 
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))isMobile = true})(w.navigator.userAgent);
    } //if

    OBOXADS.vars.mobile = isMobile;
};

/**
 * @memberof localFunctions
 */
var viewportSmallerThan = function (target) {
    var w = parseInt(target[0]),
        h = parseInt(target[1]);
    return ( (w > OBOXADS.vars.viewportSize.width || w === 0)
        && (h > OBOXADS.vars.viewportSize.height || h === 0));
};

/**
 * @memberof localFunctions
 */
var viewportLargerThan = function (target) {
    var w = parseInt(target[0]),
        h = parseInt(target[1]);
    return ( (w <= OBOXADS.vars.viewportSize.width || w === 0)
        && (h <= OBOXADS.vars.viewportSize.height || h === 0) );
};

/**
 * Checks if element el is visible in viewport
 * 
 * adapted from {@link http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433 | this StackOverflow Question}
 * @memberof localFunctions
 * 
 * @param {DOMElement} el - element to test visibility on
 * @param {number} percentage  - percentage of element that must be visible for it to be true, defaults to 1.  
 *     0.25 would mean 25% needs to be in viewport to be considered visible.
 * @param {number} adjust - pixels to offset this test, defaults to 0.
 *     100 would mean that the test would return true if element is 100 pixels within being visible
 * @returns {boolean} true if visible or false if no visible in viewport (with adjustments)
 */
var isElementInViewport = function (el, percentage, adjust) {

    var rect, hAdjust, vAdjust,
        percentage = 1 - percentage || 0,
        adjust = adjust || 0;

    // if el doesn't exist or is not displayed
    // trick to check if el is displayed http://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom
    if (!el || el.offsetParent === null) {
        return false;
    } //if

    rect = el.getBoundingClientRect();
    hAdjust = adjust + (el.offsetWidth * percentage);
    vAdjust = adjust + (el.offsetHeight * percentage);

    return (
        (rect.top + hAdjust) >= 0 &&
        (rect.left + vAdjust) >= 0 &&
        (rect.bottom  - vAdjust)  <= (w.innerHeight || d.documentElement.clientHeight) && 
        (rect.right - hAdjust) <= (w.innerWidth || d.documentElement.clientWidth) 
    );
};

/**
 * Extracts all sections from URL and returns them in an array
 * removes prefix and suffix slashes
 * @memberof localFunctions
 */
var getPathParts = function(path) {
    path = path || location.pathname;
    path = path.replace(/^\/+|\/+$/g,''); // remove trailing slashes

    return ( path === "" ? [] : path.split('/') ) ;
};

/**
 * This is the point of entry for the application.
 *
 * it initialises the libraries and processes all banners
 *
 * @memberof localFunctions
 */
var start = function () {
    let isInitComplete = false;
    let isDomReady = false;
    const loadedHandler = () => {
      if (isInitComplete && isDomReady) {
       /**
        * Event fired when OBOADS has been fully initialized and document is ready
        *
        * @memberof OBOXADS
        * @event loaded
        * @type {object}
        */
        OBOXADS.fn.emit('loaded', {}, true); 
      } //if
    }

    OBOXADS.fn.domReady(function() {
      isDomReady = true;
      loadedHandler()
    });

    OBOXADS.fn.on('initComplete', () => {
      isInitComplete = true;
      OBOXADS.fn.addAllBanners();
      // make it run after initComplete has finishied
      window.setTimeout(loadedHandler, 0)
    });

    OBOXADS.fn.init(); 
};

/**
 * Adds custom CSS to the current document
 * @memberof localFunctions
 * @method
 * @param {string} css - css rules to add
 *
 * @example
 * // add some margin to the first side banner
 * addCss([
 *   '.oboxads-side-1 {',
 *   '  margin-top: 10px;',  
 *   '}'
 * ].join('\n'));
 */
var addCSS = (function () {
  var customStyle = null;
  return function (css) {
      var head, style;
      if (customStyle === null) {
          head = d.head || d.getElementsByTagName('head')[0];
          style = d.createElement('style');
          head.appendChild(style);
      } //if

      if (style.styleSheet){
        style.styleSheet.cssText += "\n" + css;
      } else {
        style.appendChild(d.createTextNode(css));
      }
  };
})();

/**
 * Adds a custom size to a slot
 * @memberof localFunctions
 *
 * @param {string} slotName - name of slot to modify eg. side-2
 * @param {number[]|boolean} resolution - resolution array to modify or false modify default sizes
 * @param {number[]} size - size to add
 * @param {string=} templateSlot - if a slot definition does not exists it will use this slot as its base
 *
 * @example
 * // add 300x1050 support for side-1 on tablet
 * slotAddSize('side-1', tabletSize, [300, 1050], 'side');
 *
 * // add 300x1050 support for side-1 for default sizes
 * slotAddSize('side-1', false, [300,1050]);
 */
var slotAddSize = function (slotName, resolution, size, templateSlot) {
    var w = resolution[0],
        h = resolution[1];

    if (!slotSettings.hasOwnProperty(slotName)) {
        templateSlot = templateSlot || slotName.slice(0,-2);
        if (!slotSettings.hasOwnProperty(templateSlot)) {
            templateSlot = '_any_';
        } //if

        // do an object copy using JSON.parse
        // see http://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
        slotSettings[slotName] = JSON.parse(JSON.stringify(slotSettings[templateSlot]));
    } //if
   
    if (resolution === false) {
       slotSettings[slotName].defaultSizes.push(size);
    } else {
        slotSettings[slotName].mapping.forEach(function(mapping, index) {
            if (mapping.resolution[0] == w && mapping.resolution[1] == h) {
                slotSettings[slotName].mapping[index].sizes.push(size);
            } //if
        });
    } //if
};


/**
 * Remove a supported size from a slot
 *
 * @memberof localFunctions
 * @method
 *
 * @param {string} slotName - name of slot to modify eg. side-2
 * @param {number[]|boolean} resolution - resolution array to modify or false modify default sizes
 * @param {number[]} size - sizes to add
 * @param {string=} templateSlot - if a slot definition does not exists it will use this slot as its base
 *
 * @example
 * // remove 300x600 support from side-1 on tablet
 * slotRemoveSize('side-1', tabletSize, [300, 600] , 'side');
 *
 * // remove 300x600 support from side-1 on default sized
 * slotRemoveSize('side-1', false, [300,600]);
 */
var slotRemoveSize = (function () {
  /** 
   * returns true if size array and item match
   * @param {number[]} size - size to match
   * @param {number[]} item - item to compare to size
   * @returns {boolean} 
   */
   var sizeMatch = function (size, item) {
     return !(size[0] === item[0] && size[1] === item[1]);
   };

  return function (slotName, resolution, size, templateSlot) {
    var w = resolution[0],
      h = resolution[1],
      filterOutSize = sizeMatch.bind(null, size);

    if (!slotSettings.hasOwnProperty(slotName)) {
      templateSlot = templateSlot || slotName.slice(0,-2);
      if (!slotSettings.hasOwnProperty(templateSlot)) {
        templateSlot = '_any_';
      } //if

        // do an object copy using JSON.parse
        // see http://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
        slotSettings[slotName] = JSON.parse(JSON.stringify(slotSettings[templateSlot]));
    } //if

    if (resolution === false) {
      slotSettings[slotName].defaultSizes = slotSettings[slotName].defaultSizes.filter(filterOutSize);
    } else {
      slotSettings[slotName].mapping.forEach(function(mapping, index) {
        if (mapping.resolution[0] == w && mapping.resolution[1] == h) {
          slotSettings[slotName].mapping[index].sizes = mapping.sizes.filter(filterOutSize);
        } //if
      });
    } //if
  };
})();

/**
 * setup checks for supported post messages for passbacks
 * @memberof localFunctions
 */
var setupPostMessageHandlers = function () {
  OBOXADS.fn.addEvent(w,'message', (e) => {
    if (typeof e.data === 'object' && e.data.hasOwnProperty('type')) {
      if (e.data.type.indexOf('oboxads-passback') === 0) {
        let event = JSON.parse(JSON.stringify(e.data));
        event.type = event.type.substr(17);

        /**
         * Event fired when a passback post message is received
         *
         * @memberof OBOXADS
         * @event passback
         * @type {object}
         */
        OBOXADS.fn.emit(`passback:${event.type}`, event); 
      } else if (e.data.type.indexOf('oboxads-') === 0) {
        let event = JSON.parse(JSON.stringify(e.data));
        event.type = event.type.substr(8);

        /**
         * Event fired when a generic oboxads post message is received
         *
         * @memberof OBOXADS
         * @event postMessage
         * @type {object}
         */
        OBOXADS.fn.emit(`postMessage:${event.type}`, event); 
      } //if
    } //if
  });
} // setupPostMessageHandlers

/**
 * Detects utms paramters for the user's session
 * @memberof localFunctions
 */
var detectUTMs = function () {
  let vars = OBOXADS.vars;

  // get previously set values from session storage
  vars.utmCampaign = sessionStorage.getItem('oboxads-utmCampaign') || '';
  vars.utmSource = sessionStorage.getItem('oboxads-utmSource') || '';
  vars.utmMedium = sessionStorage.getItem('oboxads-utmMedium') || '';
  vars.utmTerm = sessionStorage.getItem('oboxads-utmTerm') || '';
  vars.utmContent = sessionStorage.getItem('oboxads-utmContent') || '';

  // override or set values if present in URL params
  for (let param in vars.urlParams) {
    const paramLower = param.toLowerCase();
    if (paramLower.substr(0,4) === 'utm_') {

      if (paramLower === 'utm_campaign') {
        vars.utmCampaign = vars.urlParams[param];
        sessionStorage.setItem('oboxads-utmCampaign',vars.utmCampaign);
      } else if (paramLower === 'utm_source') {
        vars.utmSource = vars.urlParams[param];
        sessionStorage.setItem('oboxads-utmSource',vars.utmSource);
      } else if (paramLower === 'utm_medium') {
        vars.utmMedium = vars.urlParams[param];
        sessionStorage.setItem('oboxads-utmMedium',vars.utmMedium);
      } else if (paramLower === 'utm_term') {
        vars.utmTerm = vars.urlParams[param];
        sessionStorage.setItem('oboxads-utmTerm',vars.utmTerm);
      } else if (paramLower === 'utm_content') {
        vars.utmContent = vars.urlParams[param];
        sessionStorage.setItem('oboxads-utmContent',vars.utmContent);
      } // if

    } // if

  } //for

} // setupPostMessageHandlers

/**
 * Keeps track of pageviews per session (sessionDepth)
 * @memberof localFunctions
 */
var detectSessionDepth = function () {

  // get previously set values from session storage
  OBOXADS.vars.sessionDepth = parseInt(sessionStorage.getItem('oboxads-sessionDepth')) || 0;

  const incrementSessionDepth = () => {
    OBOXADS.vars.sessionDepth += +1;
    sessionStorage.setItem('oboxads-sessionDepth', OBOXADS.vars.sessionDepth);
  };

  incrementSessionDepth();
  OBOXADS.fn.on('pageView', incrementSessionDepth);

  /* update sessionDepth k/v when banners are lazy loaded or refreshed */
  const updateKeyValue = (e) => {
    const sessionDepth = OBOXADS.vars.sessionDepth;
    e.slotsToShow.forEach((slot) => {
      slot.setTargeting("sessionDepth", sessionDepth);
    });
  };

  OBOXADS.fn.on('bannerShow', updateKeyValue);
  OBOXADS.fn.on('bannerRefresh', updateKeyValue);

} // detectSessionDepth

/**
 * checks if content categories are and set and handle special cases
 * @memberof localFunctions
 */
var setupContentCategoryHandlers = function () {

  OBOXADS.fn.on('initComplete', () => {
    const contentCategories = OBOXADS.vars.contentCategories;

    switch (true) {

      // OBOX1-2 - Ad Free Content
      case contentCategories.hasOwnProperty('OBX1-2'):
        OBOXADS.vars.showAds = false;

        if (OBOXADS.vars.addons.hasOwnProperty('inImage')) {
          OBOXADS.vars.addons.inImage.showAds = false;
        } //if

        if (OBOXADS.vars.addons.hasOwnProperty('outstream')) {
          OBOXADS.vars.addons.outstream.showAds = false;
        } //if

        break;

      // OBOX1-1 - Sponsored Content
      case contentCategories.hasOwnProperty('OBX1-1'):

        if (OBOXADS.vars.addons.hasOwnProperty('outstream')) {
          OBOXADS.vars.addons.outstream.showAds = false;
        } //if

        if (OBOXADS.vars.addons.hasOwnProperty('staticAdsense')) {
          OBOXADS.vars.addons.staticAdsense.showAds = false;
        } //if

        if (OBOXADS.vars.addons.hasOwnProperty('impactContentAds')) {
          OBOXADS.vars.addons.impactContentAds.showAds = false;
        } //if

        if (OBOXADS.vars.addons.hasOwnProperty('inImage')) {
          OBOXADS.vars.addons.inImage.showAds = false;
        } //if

        OBOXADS.fn.on('bannerConfig', (e) => {
          switch (e.tagInfo.slotName) {
            case 'header-1':
            case 'side-1':
            case 'content-1':
              // do nothing;
              break;
            default:
              e.preventDefault = true;
              break;
          } //switch
        });

        break;
    } // switch
  });

} // setupContentCategoryHandlers

const TagInfo = function(section, pos) {
  this.section = section;
  this.position = pos;
  this.context = '';
  this.status = TagInfo.STATUS_NEW;
  this.el = null;
  this.slotName = `${section}-${pos}`;
  this.currentAd = null;
  this.previousAds = [];
  this.slot = null;
  this.slotSetting = null;
}

TagInfo.prototype.setCurrentAd = function (adInfo) {
  if (this.currentAd !== null) {
    this.previousAds.push(this.currentAd);
  } //if

  this.currentAd = adInfo;
};

TagInfo.STATUS_NEW          = 'new';
TagInfo.STATUS_CONFIG       = 'config';
TagInfo.STATUS_DISABLED     = 'disabled';
TagInfo.STATUS_CUSTOM       = 'custom';
TagInfo.STATUS_ADDED        = 'added';
TagInfo.STATUS_READY        = 'ready';
TagInfo.STATUS_REQUEST_SENT = 'request sent';
TagInfo.STATUS_LOADED       = 'loaded';
TagInfo.STATUS_ERROR        = 'error';

const AdInfo = function () {
  this.isEmpty = true;
  this.description = '';
  this.orderId = null;
  this.lineItemId = null;
  this.creativeId = null;
  this.size = [];
}

/**
 * Sets up vars, debug mode and other stuff
 *
 * @memberof OBOXADS.fn
 */
OBOXADS.fn.init = function() {
    var i, qLength, 
        oldQ = OBOXADSQ,
        vars = OBOXADS.vars;

    if (vars.ready === true) {
        return;
    } //if

    parseURLParams();
    detectUTMs();
    detectSessionDepth();
    detectViewportSize();
    detectMobile();
    setupDebugMode();
    setupPostMessageHandlers();
    setupContentCategoryHandlers();

    if (vars.urlParams.hasOwnProperty('custom')) {
        vars.custom = vars.urlParams.custom;
    } //if

    if (vars.urlParams.hasOwnProperty('custom2')) {
        vars.custom2 = vars.urlParams.custom2;
    } //if

    if (vars.urlParams.hasOwnProperty('custom3')) {
        vars.custom3 = vars.urlParams.custom3;
    } else {
        let expId = sessionStorage.getItem('oboxads-exp-id');
        if (!expId) {
          expId = "exp-"+ (Math.floor(Math.random() * 10)+1)
          sessionStorage.setItem('oboxads-exp-id', expId);
        } // if

        /*
        let gaSet = false;
        OBOXADS.fn.on('bannerConfig', () => {
          if (gaSet) {
            return
          } // if

          if (window.hasOwnProperty('ga')) {
            gaSet = true
            ga('publisherTracker.set', 'exp-id', expId);
            log('setting exp-id dimension', expId)
          }

        })
        */
        vars.custom3 = expId
        log('experiment', expId)
    } //if

    // cookie not set yet. start impression counter to 0
    var cookieInfo = OBOXADS.fn.readCookie("dailyBannerView");
    if(cookieInfo === null){
        cookieInfo = 0;

        // set point of entry flag if it hasn't been set
        if (vars.adUnit !== 'homepage' && vars.deliveryFlags.pointOfEntry === null) {
            vars.deliveryFlags.pointOfEntry = true;
        } //if
    }
    OBOXADS.vars.dailyBannerView = cookieInfo;

    /**
     * Event fired just before the OBOXADSQ is processed
     *
     * @memberof OBOXADS
     * @event beforeInitLoop
     * @type {object}
     */
    OBOXADS.fn.emit('beforeInitLoop');

    // replace OBOXADSQ array by object that implements push
    OBOXADSQ = {
        "push": function (params) {
            if (params && params.cmd && OBOXADS.fn[params.cmd]) {
                OBOXADS.fn[params.cmd](params);
            } else if (typeof params === 'function') {
                params();
            } else {
                log('Unsupported op', params);
            } //if
        }
    };
    OBOXADSQ.unshift = OBOXADSQ.push;

    // loop over items that were pushed before lib was initialized
    oldQ.forEach(OBOXADSQ.push);

    let complete = false;
    const initEnd = () => {
      if (complete) {
        return;
      } // if

      complete = true;
      if (OBOXADS.fn.hasOwnProperty("initTargeting")) {
        OBOXADS.fn.initTargeting();
      } //if
      
      vars.ready = true;
    
      /**
       * Event fired when init is complete and OBOXADS is marked as ready
       *
       * @memberof OBOXADS
       * @event initComplete
       * @type {object}
       */
      OBOXADS.fn.emit('initComplete', {}, true);
    }
  
  
    if (waitingForResources > 0) {
      OBOXADS.fn.on('resourcesReady', initEnd);
      window.setTimeout(initEnd, 1000);
    } else {
      initEnd()
    } // if

};

!function (locked, map) {
  /**
   * takes all properties of params and update
   * the value of the OBOXADS.vars property of the
   * same name
   *
   * @memberof OBOXADS.fn
   *
   * @param {object} params - key/values to updated
   */
    OBOXADS.fn.config = function(params) {
      var prop,
        mappedProp,
        vars = OBOXADS.vars;
      for (prop in params) {
  // check if its locked from being overridden
  if (!locked.hasOwnProperty(prop)) {
    mappedProp  = map.hasOwnProperty(prop) ? map[prop] : prop;
    vars[mappedProp] = params[prop];
  } //if
      } //for

      /**
       * Event fired when config has been updated
       *
       * @memberof OBOXADS
       * @event configUpdated
       * @type {object}
       */
      OBOXADS.fn.emit('configUpdated', vars , true );
    };
}({ // locked
    "ready": 1,
    "cmd": 1
  },
  { //map
    "postId": "uniqueId"
  });

OBOXADS.fn.log = log; // use local function log    

/**
 * cross browser event registration
 *
 * @memberof OBOXADS.fn
 *
 * @param {obj} obj - object that will emit events
 * @param {string} type - the event to listen for
 * @param {function}  - event handler callback
 */
OBOXADS.fn.addEvent = function (obj,type,fn) {
  var r;

  if (obj.addEventListener) {
    obj.addEventListener(type,fn,false);
    return true;
  } else if (obj.attachEvent) {
    obj['e'+type+fn] = fn;
    obj[type+fn] = function() { obj['e'+type+fn]( w.event );};
    r = obj.attachEvent('on'+type, obj[type+fn]);
    return r;
  } else {
    obj['on'+type] = fn;
    return true;
  }

}; //addEvent

/**
 * registers event listenners for given event 
 *
 * @memberof OBOXADS.fn
 *
 * @param {String} eventName - name of the event to listen for
 * @param {Function} callback - function to call when event happens will be passed an event Object
 */
OBOXADS.fn.on = function (eventName, callback) {
  eventListeners[eventName] = eventListeners[eventName] || [];
  eventListeners[eventName].push(callback);

  // if event log is enabled trigger callback
  // for logged events
  if (eventsLog.hasOwnProperty(eventName)) {
    eventsLog[eventName].forEach(callback);
  } //if
}; //loadScript

/**
 * emit event to all registered listenners 
 *
 * @memberof OBOXADS.fn
 *
 * @param {String} eventName - name of the event that just happenned
 *    Note that if event name contains colons will fire multiple events for each section
 *    for example bannerconfig:header:1
 *    will fire 3events:
 *     * bannerConfig
 *     * bannerConfig:header
 *     * bannerConfig:header:1
 * @param {Object} eventObj - object containing event information
 * @param {Boolean} logEvent - (optional) weather we should log this event
 *    logged event will be passed to new event listenner for that event
 */
OBOXADS.fn.emit = function (eventName, eventObj, logEvent) {
  eventObj = eventObj || {};

  if (!eventObj.hasOwnProperty('stopPropagation')) {
    eventObj.stopPropagation = false;
  } //if

  if (!eventObj.hasOwnProperty('preventDefault')) {
    eventObj.preventDefault = false;
  } //if

  var currentEvent = '';
  eventName.split(':').forEach(function(part) {
    currentEvent += part;

    if (logEvent) {
      eventsLog[currentEvent] = eventsLog[currentEvent] || [];
      eventsLog[currentEvent].push(eventObj); 
    } //if

    if (eventListeners.hasOwnProperty(currentEvent)) {
      eventListeners[currentEvent].forEach(function (callback) {
        if (eventObj.stopPropagation !== true) {
          callback.call(null, eventObj);
        } //if
      });
    } //if
    currentEvent += ':';
  });

  return eventObj;
}; //emit

/**
 * dynamically load external script and call a callback when loaded 
 *
 * @memberof OBOXADS.fn
 */
OBOXADS.fn.loadScript = function (src, callback) {
    var p = allScripts[0],
        tag =  (src.split('?')[0].substr(-4) === '.css' ? 'link' : 'script'),
        e = d.createElement(tag);

    if (tag === 'link') {
      e.rel = "stylesheet";
      e.type = "text/css";
      e.href = src;
    } else {
      e.src = src;
    } //if

    if (callback) {
        if (d.all) { // IE 6
            e.onreadystatechange = function() {
                if (e.readyState == 'complete' || e.readyState == 'loaded') {
                    e.onreadystatechange = null;
                    callback();
                } //if
            };
        } else {
            OBOXADS.fn.addEvent(e,'load', callback);
        } //if
    } //if
    p.parentNode.insertBefore(e,p);
}; //loadScript

/**
 * calls a function when document is ready
 *
 * @memberof OBOXADS.fn
 *
 */
OBOXADS.fn.domReady = function (callback) {
    var addEvent = OBOXADS.fn.addEvent,
        readyState = d.readyState ?  d.readyState : ""; 
    if (readyState === "complete" || readyState == "interactive") {
        callback();
    } else if (d.addEventListener) {
        addEvent(d, "DOMContentLoaded", callback);
    } else if (d.addEvent) {
        addEvent(d, 'readystatechange', function () {
            if (d.readyState === "complete") {
                callback();
            } //if
        });
    } //if
}; //domReady

/**
 * loops through all script tags and look for unprocessed oboxads
 * tags, if such tag is found addBanner is called
 *
 * @memberof OBOXADS.fn
 *
 */
OBOXADS.fn.addAllBanners = function () {
  var scripts = Array.prototype.slice.call(allScripts);
    
    scripts.forEach(function(script) {
    var el = script.parentNode;
    if (el.className === 'oboxads') {
      OBOXADS.fn.addBanner({el: el});
    } //if
  });
};

/**
 * builds a hash value from a string
 *
 * based on code found here: http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery

 * @memberof OBOXADS.fn
 */
/*  */
OBOXADS.fn.getHash = function (str) {
    var i, l = str.length,
        hval = 0x811c9dc5;
    for (i = 0; i < l; i++) {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    } //for
    return hval >>> 0;
}; //getHash

/**
 * @memberof OBOXADS.fn
 */
OBOXADS.fn.readCookie = function (name) {
  var i, c,
    nameEQ = name + "=",
    ca = document.cookie.split(';');
  for (i = 0; i < ca.length; i++) {
    c = ca[i];
    while (c.charAt(0) == ' ') { 
      c = c.substring(1, c.length);
    } // while 

    if (c.indexOf(nameEQ) == 0) {
      return c.substring(nameEQ.length, c.length);
    } //if
  }
  return null;
};

/**
 * Delete a cookie
 *
 * @memberof OBOXADS.fn
 *
 * @param {string} name - name of the cookie to remove
 */
OBOXADS.fn.eraseCookie = function (name) {
  //OBOXADS.fn.addCookie(name, "", -1);
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
};

/**
 * Set a cookie
 *
 * @memberof OBOXADS.fn
 *
 * @param {string} name - name of the cookie to set
 * @param {string} value - value to assign to the cookie
 * @param {date} expirationDate - when is the cookie going to expire
 */
OBOXADS.fn.addCookie = function (name, value, expirationDate) {
  let expires = "";
  if (typeof expirationDate !== 'undefined') {
    expires = "expires="+expirationDate.toGMTString();
  }
  document.cookie = `${name}=${value};${expires};path=/`;
};

/**
 * Called when a gallery is initialized
 *
 * @memberof OBOXADS.fn
 *
 * @param {object} params - various gallery paramaters
 * @param {object} params.gallery - reference to the gallery
 *
 * @fires initGallery
 * 
 */
OBOXADS.fn.initGallery = function (params) {
  /**
   * Event fired when a gallery is initialized
   *
   * @memberof OBOXADS
   * @event initGallery
   * @type {object}
   * @property {PhotoSwipe} gallery - instance of the PhotoSwipe gallery
   */
  let e = {};

  if (params.hasOwnProperty('gallery')) {
    e.gallery = params.gallery
  } else if (params.hasOwnProperty('selector')) {
    e = params;
  } //if

  OBOXADS.fn.emit('initGallery', e, true );
};

/**
 * Called when a video player is initialized
 *
 * @memberof OBOXADS.fn
 *
 * @param {object} params - various video player parameters
 * @param {object} params.videoPlayer - reference to the video Player
 *
 * @fires initVideoPlayer
 *
 */
OBOXADS.fn.initVideoPlayer = function (params, adUnit, opts) {
  /**
   * Event fired when a video container is detected and eligible for video ads.
   * @memberof OBOXADS
   * @event initVideoPlayer
   * @type {object}
   *
   */
  OBOXADS.fn.emit('initVideoPlayer', {videoPlayer: params, adUnit, opts}, true );
};

/**
 * Detect video players in a page.
 *
 * @memberof OBOXADS.fn
 * @fires detectVideoPlayer
 *
 */
OBOXADS.fn.detectVideoPlayer = function (time, timerCount) {

  var iframeArray = document.getElementsByTagName("iframe");
  if (iframeArray.length > 0) {
    log('Obox Video Player: iframe detection done');
    var i = 0;
    var str = "";
    var pattern = /https?:\/\/(player.vimeo.com\/video\/|www.youtube.com\/embed\/)/;
    var regex = "";
    var videoIdPattern;
    var matchedVideoId;
    var matchedVideos = [];

    for (i = 0; i < iframeArray.length; ++i) {
      str = iframeArray[i].parentElement.innerHTML.toString();
      var matchedPattern = str.match(pattern);
      if (str.match(pattern) !== null && iframeArray[i].parentElement.tagName !== 'BODY') {
        switch (true) {
          // Youtube Video, upcoming feature.
          /*case /youtube\.com/.test(matchedPattern[0]) :
            videoIdPattern = /embed\/(.{11})/;
            matchedVideoId = str.match(videoIdPattern);
  
            var detectedVideo = {};
            detectedVideo.parentElement = iframeArray[i].parentElement.outerHTML.toString();
            detectedVideo.src = 'youtube';
            detectedVideo.videoId = matchedVideoId[1];
            break; */
          case /vimeo\.com/.test(matchedPattern[0]) :
            
            videoIdPattern = /video\/(\d*)/;
            matchedVideoId = str.match(videoIdPattern);
            var detectedVideo = {};
            detectedVideo.parentElement = iframeArray[i].parentElement.outerHTML.toString();
            
            if (iframeArray[i].parentElement.className === '') { 
              iframeArray[i].parentElement.classList.add('fluid-width-video-wrapper');
            }
            detectedVideo.parentClassName = iframeArray[i].parentElement.className;
            
            detectedVideo.src = 'vimeo';
            detectedVideo.videoId = matchedVideoId[1];
            matchedVideos.push(detectedVideo);

            addCSS([
              'div.' + detectedVideo.parentClassName +' div.content_video-dimensions {',
              '  width: 100% !important;',
              '  height: 385px !important;',
              '  padding-bottom: 56.25% !important;',
              '  padding-top: 25px !important;',
              '}',
              '.css-videos.portrait video#content_video_html5_api {',
              '  width: 100% !important;',
              '  height: 100% !important;',
              '}',
              'div#content_video_ima-ad-container div video {',
              '  left: 0;',
              '  height: 100% !important;',
              '}',
              'div.'+ detectedVideo.parentClassName + ' {',
              '  display: none',
              '}'
            ].join("\n"));
            break;
          default: 
            // Obox Video Player: Video Embed not properly parsed.
            break;
        } // switch
      } // if
    } // for
    return matchedVideos;
  } else {
    if (timerCount < 5) {
      log('Obox Video Player: Waiting for video element in DOM.');
      setTimeout(function() {
        OBOXADS.fn.detectVideoPlayer(time, timerCount);
      }, time);  
    } else {
      //'Obox Video Player: End of Video Detection after 5 seconds'.
    }
  }
};
/**
 * Called when a google analytics page view is recorded
 *
 * @memberof OBOXADS.fn
 *
 * @fires pageView
 * 
 */
OBOXADS.fn.pageView = function (params) {
  /**
   * Event fired when a page view is recorded
   * @memberof OBOXADS
   * @event pageView
   * @type {object}
   */
  let e = {};

  log('pageView');
  OBOXADS.fn.emit('pageView', e, true );
};

!function () {

  let bannersToTrack = []; // list of banners to check
  let bannerElements = {};  // cache of DOM elements for banners
  let noUpdateCount = 0; // keep track how many ms we didn't get an update on the viewport
  let checkInterval = 150; // check every 150ms
  let loadOffset = 250; // numbers pixels before banners enters viewport to start loading 
  let viewportUpdatedFlag = true; // was there an update in viewport elements
  let nextCheckTimerId = null;

  /**
   * filter to remove all null elements
   */
  const filterNulls = function(slotName) {
    return !!slotName;
  };

  /**
   * establish if banner is in viewport
   */
  const isBannerInViewport = function (slotName, index) {

    // oop and special ad banners are always considered in viewport
    if (slotName.indexOf('oop-') === 0 || slotName.indexOf('special-') === 0) {
      if (index >= 0) {
        bannersToTrack[index] = null; 
      } //if
      return true;
    } //if

    // cache banner containers
    if (!bannerElements[slotName]) {
      bannerElements[slotName] = d.getElementById('oboxads-'+ slotName);
    } //if

    let el = bannerElements[slotName];
    if (el && isElementInViewport(el, 0.25, loadOffset)) {
      if (index >= 0) {
        bannersToTrack[index] = null; 
      } //if
      return true;
    } //if

    return false;

  };

  /**
   * check the list of banners that we track if they 
   * are in the viewport if so trigger event
   */
  const checkBanners = function() {
    if (viewportUpdatedFlag) {
      viewportUpdatedFlag = false;
      noUpdateCount = 0;

      let bannersInView = bannersToTrack.slice().filter(isBannerInViewport);
      
      if (bannersInView.length > 0) {
        bannersToTrack = bannersToTrack.filter(filterNulls);
       /**
        * Event fired when a monitored banner becomes in view
        *
        * @memberof OBOXADS
        * @event bannersInView
        * @type {object}
        */
        OBOXADS.fn.emit('bannersInView', {banners: bannersInView});
      } //if
    } else {
      noUpdateCount += checkInterval;

      if (noUpdateCount > 1500) {
        w.clearInterval(nextCheckTimerId);
        nextCheckTimerId = null;
        noUpdateCount = 0;
      } //if
    } //if
  };

  /**
   * flag that the viewport was updated either via 
   * scroll, resize or with a  bannerReady event
   * 
   * we also set a timer to throttle the checks between 
   * updates.
   */
  const viewportUpdated = function() {
    viewportUpdatedFlag = true;
    if (nextCheckTimerId === null) {
      nextCheckTimerId = w.setInterval(checkBanners, checkInterval);    
      checkBanners();
    } //if
  };

  OBOXADS.fn.addEvent(w,'scroll', viewportUpdated);
  OBOXADS.fn.addEvent(w,'focus', viewportUpdated);
  OBOXADS.fn.addEvent(w,'resize', viewportUpdated);


  /**
   * registers banners to be monitored to see if they enter viewport
   *
   * @memberof OBOXADS.fn
   *
   */
  OBOXADS.fn.monitorBanner = function (slotName) {
    // put ready banners in a queue 
    bannersToTrack.push(slotName);
    viewportUpdated();
  }; // monitorBanner
 
}();

/* calls a function when do is ready*/
OBOXADS.fn.loadGPT = function () {
  /**
   * Event fired when GPT library script file start to load
   *
   * @memberof OBOXADS
   * @event libLoad:gpt
   * @type {object}
   */
  OBOXADS.fn.emit('libLoad:gpt', {}, true);
  OBOXADS.fn.loadScript('//www.googletagservices.com/tag/js/gpt.js');
}; //loadGPT

// make sure gooletag is defined
w['googletag'] = w['googletag'] || {};
w['googletag'].cmd = w['googletag'].cmd || [];


googletag.cmd.push(function() {
  googletag.pubads().enableSingleRequest();
 
  //Sortable update Moved to mainlib/strategies/displayHandlers/standard.js
  //googletag.pubads().disableInitialLoad();

  /**
   * Event fired when GPT library is initializing
   *
   * note that gpt services might not be enabled yet 
   *
   * @memberof OBOXADS
   * @event libInit:gpt
   * @type {object}
   */
  OBOXADS.fn.emit('libInit:gpt', {}, true);

  let cookieInfo = OBOXADS.fn.readCookie("dailyBannerView");
  let dailyBannerView = 0 ;
  if(cookieInfo !== null){
    dailyBannerView = parseInt(cookieInfo);
  }

  googletag.pubads().addEventListener('slotRenderEnded', function (event) {

    if (!event.isEmpty) {
      dailyBannerView++;
      var currentDate = new Date();
      var expirationDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()+1, 0, 0, 0);
      OBOXADS.fn.addCookie("dailyBannerView",dailyBannerView , expirationDate);
    } //if

    const slotName = event.slot.getSlotElementId().substr(8);
    let tag = null;
    if (OBOXADS.vars.tags.hasOwnProperty(slotName)) {
      tag = OBOXADS.vars.tags[slotName];
      tag.status = TagInfo.STATUS_LOADED;


      let currentAd = new AdInfo();
      currentAd.isEmpty = !!event.isEmpty;
      currentAd.orderId = event.campaignId;
      currentAd.lineItemId = event.lineItemId;
      currentAd.creativeId = event.creativeId;
      currentAd.size = event.size;

      tag.setCurrentAd(currentAd);
      
    } //if
    event.tagInfo = tag;

    event.dailyBannerView = dailyBannerView;
    event.slotName = slotName;

  /**
   * Event fired when ad server has loaded the banner scripts
   *
   * Note that eventhough the banner code is loaded there might be
   * some additonal loading of the ad assets and 3rd party code
   *
   * @memberof OBOXADS
   * @event bannerLoaded
   * @type {object}
   */
    OBOXADS.fn.emit('bannerLoaded', event, true);
  });

  /**
   * Event fired when GPT library is loaded and initialized
   *
   * @memberof OBOXADS
   * @event libReady:gpt
   * @type {object}
   */
  OBOXADS.fn.emit('libReady:gpt', {}, true);

});

// make sure its called when lib is ready
OBOXADSQ.push({"cmd": "loadGPT"});

slotSettings["header"] = {
    "defaultSizes": [ [728,90], [970,90],[970,125],[970, 250], 'fluid' ],
    "mapping": [
        { "resolution": desktopSize, "sizes": [ [728,90], [970,90],[970,125],[970, 250], 'fluid' ] },
        { "resolution": tabletSize, "sizes": [ [728,90], [970,90], [970,125],[970, 250], 'fluid'  ] },
        { "resolution": mobileSize, "sizes": [ [300, 250], [300, 100], [320, 50], [300, 50], 'fluid'  ] }
    ]
};

slotSettings["side"] = {
    "defaultSizes": [ [300, 250],'fluid' ],
    "mapping": [
        //{ "resolution": desktopSize, "sizes": [ [300, 250] ] },
        { "resolution": tabletSize, "sizes": [ [300, 250], 'fluid'  ] },
        { "resolution": mobileSize, "sizes": [ [300,250], [300,100], [320,50], [300, 50], 'fluid'  ] }
    ]
};

slotSettings["content"] = {
    "defaultSizes": [ [300, 250], 'fluid' ],
    "mapping": [
        //{ "resolution": desktopSize, "sizes": [ [300, 250] ] },
        { "resolution": tabletSize, "sizes": [ [300, 250],'fluid' ] },
        { "resolution": mobileSize, "sizes": [ [300,250], [300,100], [320,50], [300, 50],'fluid' ] }
    ]
};

slotSettings["footer"] = {
    "defaultSizes": [ [728,90], 'fluid'  ],
    "mapping": [
        //{ "resolution": desktopSize, "sizes": [ [970, 250], [970,90],[728,90] ] },
        { "resolution": tabletSize, "sizes": [ [728,90], 'fluid' ] },
        { "resolution": mobileSize, "sizes": [ [300, 250], [300, 100], [320, 50], [300, 50], 'fluid' ] }
    ]
};

slotSettings["special"] = {
    "defaultSizes": [ [728,90] ],
    "mapping": [
        { "resolution": tabletSize, "sizes": [ [728,90], 'fluid' ]},
        { "resolution": mobileSize, "sizes": [ [300,100], [320,50], [300, 50], 'fluid' ] }
    ]
};

slotSettings["side-1"] = {
    "defaultSizes": [ [300, 600], [160,600], [300,250],'fluid' ],
    "mapping": [
        //{ "resolution": desktopSize, "sizes": [ [300, 600], [160,600], [300, 250] ] },
        { "resolution": tabletSize, "sizes": [ [300, 600], [160,600], [300, 250], 'fluid' ] },
        { "resolution": mobileSize, "sizes": [ [300,250], [300,100], [320,50], [300, 50], 'fluid' ] }
    ]
};

// set one pixel over to avoid remnant
slotSettings["side-promo"] = {
    "defaultSizes": [ [300, 101], [300,126], [300,151], 'fluid' ],
    "mapping": [
        { "resolution": mobileSize, "sizes": [ [300,101], [300,126],  [300,151], 'fluid' ]}
    ]
};

slotSettings["content-1"] = {
    "defaultSizes": [ [300, 250], 'fluid' ],
    "mapping": [
        //{ "resolution": desktopSize, "sizes": [ [300, 250] ] },
        { "resolution": tabletSize, "sizes": [ [300, 250], 'fluid' ] },
        { "resolution": mobileSize, "sizes": [ [300,250], [300,100], [320,50], [300, 50], 'fluid' ] }
    ]
};

slotSettings["_any_"] = {
    "defaultSizes": [ [1, 1] ],
    "mapping": [
        { "resolution":  [0, 0], "sizes": [ [1,1] ] }
    ]
};


OBOXADS.vars.slotSettings = slotSettings;

!function () {
  var displayedSlots = {},
    slotTimer, slotBuffer = [],
    /*
     * filter that checks if a slot name 
     * has been configured or not
     */
    filterReadySlots = function (slotName) {
      if (!slots[slotName]) {
        log('slot not defined/ready', slotName);
      } //if
      return !!slots[slotName];
    },
    /*
     * maps slotName to slots also ensures that 
     * display() is called only once and when
     * slot is ready
     */
    mapNamesToSlot = function(slotName) {
      // make sure slots are displayed only one
      if (!displayedSlots.hasOwnProperty(slotName)) {
        /**
         * Event fired when a slot is about to be shown this event is fired only once per slot
         *
         * @memberof OBOXADS
         * @event slotDisplay
         * @type {object}
         */
        OBOXADS.fn.emit('slotDisplay', {slotName: slotName});
        displayedSlots[slotName] = true;
      } //if

      return slots[slotName];
    };

  const displayBanners = function(eventType, slotNames) {
    var slotsToShow;

    // handle showBanners that is passed via OBOXADSQ.push (slotNames will be object, not array)
    slotNames = (slotNames && slotNames.filter ? slotNames : []).filter(filterReadySlots);
    
    if ( slotNames.length <= 0 ) {
      return;
    } //if

    slotsToShow = slotNames.map(mapNamesToSlot);

    if (slotsToShow.length > 0) {
      slotNames.forEach((slotName) => {
        OBOXADS.vars.tags[slotName].status = TagInfo.STATUS_REQUEST_SENT;
      });
      /**
       * Event fired when a banner needs to be shown
       *
       * @memberof OBOXADS
       * @event bannerShow
       * @type {object}
       */
      /**
       * Event fired when a banner needs to be refreshed
       *
       * @memberof OBOXADS
       * @event bannerRefresh
       * @type {object}
       */
      OBOXADS.fn.emit(eventType, {slotsToShow, slotNames, options: {changeCorrelator: false} });
    } //if
  };

  /**
   * Sends ad requests to display the provided list of slots
   *
   * @memberof OBOXADS.fn
   * @method
   * @param {object=} slotNames - array of slotNames to show
   */
  OBOXADS.fn.showBanners = displayBanners.bind(null,'bannerShow');

  /**
   * Sends ad requests to refresh the provided list of slots
   *
   * @memberof OBOXADS.fn
   * @method
   * @param {object=} slotNames - array of slotNames to show
   */
  OBOXADS.fn.refreshBanners = displayBanners.bind(null,'bannerRefresh');

}();


// see OBOXADS.fn.showBanners()

/**
 * Detects parameters from html tag and defines the slot
 *
 * @memberof OBOXADS.fn
 *
 * @param {object=} params - user provideded paramaters
 */
OBOXADS.fn.addBanner = (function () {
    const getTagElement = function (params) {
        let el = null;
        if (params.el) {
            el = params.el;
        } else if (document.currentScript && document.currentScript.parentNode.className === 'oboxads') {
            el = document.currentScript.parentNode;
        } else {
            let allScripts = document.scripts;
            let scriptLength = allScripts.length;
            for (var i = -1; i < scriptLength; i++) {
                if (allScripts[i] && allScripts[i].parentNode.className === 'oboxads') {
                    el = allScripts[i].parentNode;
                    break;
                } //if
            } //for
        } //if

        return el;
    };

    return function (params = {}) {
        var el = null, data, attibs, i,
            attribsLen, dataRegEx, customFunction,
            slotSetting, slotName, slotId,
            slotContext,
            i,
            vars = OBOXADS.vars;

        if (!(vars.ready && vars.showAds)) {
            return;
        } //if

        el = getTagElement(params);
        params.el = el;

        if (el === null) {
            log('Empty el', allScripts[allScripts.length - 1]);
            return;
        } //if

        if (el.dataset) {
            data = el.dataset;
        } else {
            data = {};
            dataRegEx = /^data-/;
            for (attribs = el.attributes, attribsLen = attribs.length, i = 0; i < attribsLen; i++) {
                if (dataRegEx.test(attribs[i].name)) {
                    data[attribs[i].name.substring(5)] = attribs[i].value;
                } //if
            } //for

        } //if

        var abort = false;
        var match;
        if (data.hasOwnProperty('minRes')) {
            match = data['minRes'].match(/\[(\d+)\,(\d+)\]/);
            if (match && match.length >= 3 && !viewportLargerThan([match[1], match[2]])) {
                abort = true;
            } //if
        } // if

        if (data.hasOwnProperty('maxRes')) {
            match = data['maxRes'].match(/\[(\d+)\,(\d+)\]/);
            if (match && match.length >= 3 && !viewportSmallerThan([match[1], match[2]])) {
                abort = true;
            } //if
        } //if

        params.section = data.section;
        params.context = data.hasOwnProperty('context') ? data.context : '';

        if (vars.sectionPosition.hasOwnProperty(params.section)) {
            vars.sectionPosition[params.section]++;
        } else {
            vars.sectionPosition[params.section] = 1;
        } //if
        params.pos = vars.sectionPosition[params.section];

        const tagInfo = new TagInfo(params.section, params.pos);
        vars.tags[tagInfo.slotName] = tagInfo;
        tagInfo.context = params.context;
        tagInfo.el = el;

        // check if we have a custom function for current section and position
        customFunction = vars.customFunctions[params.section + '-' + params.context]
            || vars.customFunctions[params.section + '-' + params.pos]
            || vars.customFunctions[params.section]
            || vars.customFunctions['_any_'];
        if (customFunction) {
            log('Custom code for ' + params.section + '[pos=' + params.pos + ']');
            el.className += ' oboxads-custom';
            if (customFunction(params, el) === false) {
                abort = true;
            } //if
        } //if

        /**
         * Event fired when tag paramters have been processed
         *
         * can be used to override tag behavior or parameters. 
         *
         * You can also prevent default banner behavior by setting the preventDefault property of the event Object
         *
         * @example <caption>Get all bannerConfig events</caption>
         *
         *   OBOXADS.fn.on('bannerConfig', function (e) {
         *     e.preventDefault = true;
         *   });
         *
         *
         * @example <caption>Get tag specific bannerConfig event</caption>
         *
         *   OBOXADS.fn.on('bannerConfig:header', function () {});
         *   OBOXADS.fn.on('bannerConfig:side:2', function () {});
         *
         * @memberof OBOXADS
         * @event bannerConfig
         * @type {object}
         */
        var eventObj = { params, el, tagInfo };
        OBOXADS.fn.emit(`bannerConfig:${params.section}:${params.pos}`, eventObj, true);

        if (params.context !== "") {
            /**
             * Event fired when tag paramters have been processed and a context attribute has been set
             *
             * can be used to override tag behavior or parameters
             *
             * @memberof OBOXADS
             * @event bannerConfigContext
             * @type {object}
             */
            OBOXADS.fn.emit(`bannerConfigContext:${params.section}:${params.context}:${params.pos}`, eventObj, true);
        } //if

        slotName = params.section + '-' + params.pos;
        slotContext = params.section + '-' + params.context;
        slotId = 'oboxads-' + slotName;

        // add classes and id to tag element
        el.className += [' oboxads-', slotName, (params.context.length > 0 ? ' oboxads-' + slotContext : ''), ' oboxads-', params.section].join('');
        let foundChild = false;
        let currentChild = 0;
        const childCount = el.childNodes.length;
        let child = null;
        while (!foundChild && currentChild < childCount) {
            if (el.childNodes[currentChild].nodeName === 'DIV') {
                foundChild = true;
                child = el.childNodes[currentChild];
            } else {
                currentChild++;
            } //if
        } //while

        if (child) {
            child.id = slotId;
        } else {
            log(`Unable to find child element in tag (${slotName}), possibly malformed tag.`);
            tagInfo.status = TagInfo.STATUS_ERROR;
            return;
        }

        abort = eventObj.preventDefault === true ? true : abort;

        if (abort) {
            log('Disabling', params.section + '-' + params.pos);
            tagInfo.status = TagInfo.STATUS_DISABLED;
            el.className += ' oboxads-disabled';

            /**
             * Event fired when a tag has been disabled
             *
             * @memberof OBOXADS
             * @event bannerDisabled
             * @type {object}
             */
            OBOXADS.fn.emit('bannerDisabled', { params, el, tagInfo }, true);
            return;
        } //if


        // get first set of define slot settings
        slotSetting = tagInfo.slotSetting || slotSettings[slotContext + '-' + params.pos] ||
            slotSettings[slotContext] || slotSettings[slotName] ||
            slotSettings[params.section] || slotSettings['_any_'];

        tagInfo.slotSetting = slotSetting;
        tagInfo.status = TagInfo.STATUS_ADDED;

        /**
         * Event fired when a banner tag has been parsed and configured
         *
         * note that the slot associated to banner has not yet been defined
         *
         * @memberof OBOXADS
         * @event bannerAdded
         * @type {object}
         */
        OBOXADS.fn.emit('bannerAdded', { slotName, slotSetting, tagInfo, params }, true);

        googletag.cmd.push(function () {

            var deliveryFlags = OBOXADS.vars.deliveryFlags,
                flag, mapping, deliveryFlagsArray = [],
                fullAdUnit = '', siteKv;

            // only define slots once
            if (!slots.hasOwnProperty(slotName)) {

                for (flag in deliveryFlags) {
                    if (deliveryFlags[flag] === true) {
                        deliveryFlagsArray.push(flag);
                    } //if
                } //for

                // define slot ad unit (replace double slash  with one and remove trailing slash)
                fullAdUnit = `/${vars.netId}/${vars.site}/${vars.adUnit}`;
                fullAdUnit = fullAdUnit.replace("//", "/").replace(/\/$/, "");
                siteKv = vars.site.split('/').shift().replace(">", "|");

                if (params.section === 'oop') {
                    slots[slotName] = googletag.defineOutOfPageSlot(fullAdUnit, slotId).
                        setTargeting("embed", (params.embed ? "true" : "false")).
                        setTargeting("section", params.section).
                        setCollapseEmptyDiv(true).
                        setTargeting("site", siteKv).
                        setTargeting("pos", params.pos).
                        setTargeting("slot", params.section + '-' + params.pos).
                        setTargeting("sessionDepth", vars.sessionDepth).
                        setTargeting("deliveryFlags", deliveryFlagsArray.join(",")).
                        addService(googletag.pubads());

                } else {
                    slots[slotName] = googletag.defineSlot(fullAdUnit, slotSetting.defaultSizes, slotId).
                        setCollapseEmptyDiv(true).
                        setTargeting("embed", (params.embed ? "true" : "false")).
                        setTargeting("section", params.section).
                        setTargeting("site", vars.site.replace(">", "|")).
                        setTargeting("pos", params.pos).
                        setTargeting("slot", params.section + '-' + params.pos).
                        setTargeting("context", params.context).
                        setTargeting("sessionDepth", vars.sessionDepth).
                        setTargeting("deliveryFlags", deliveryFlagsArray.join(","));

                    if (vars.responsive) {
                        mapping = googletag.sizeMapping();
                        for (i in slotSetting.mapping) {
                            mapping.addSize(slotSetting.mapping[i]['resolution'], slotSetting.mapping[i]['sizes']);
                        }
                        slots[slotName].defineSizeMapping(mapping.build());
                    } //if

                    slots[slotName].addService(googletag.pubads());

                } //if

                tagInfo.slot = slots[slotName]

                /**
                 * Event fired when slot has been defined
                 *
                 * note that the slot associated to banner has not yet been defined
                 *
                 * @memberof OBOXADS
                 * @event slotReady
                 * @type {object}
                 */
                OBOXADS.fn.emit('slotReady', { slotName, slotSetting, tagInfo, slot: slots[slotName] });
            } else {
                tagInfo.slot = slots[slotName]
            } //if

        });

    };
})();

!function () {

  const delayedAddBanner = function () {
    (window.OBOXADSQ || []).push({"cmd": "addBanner" });
  };

  /**
   * append a tag to a DOMElement
   *
   * @memberof OBOXADS.fn
   *
   * @param {DOMElement} targetEl - container element where tag will be inserted
   * @param {string} section - name of the section for the date (header, side, etc.)
   * @param {object} options - optional options for the tag
   * @param {string} options.context - if you want to specify a context for the tag
   * @param {boolean} options.insertAfter - if you want to insert tag next to targetEl rather than append to it
   */
  OBOXADS.fn.appendTag = function (targetEl, section, options = {}) {
    const tagEl = d.createElement('div');
    const emptyDiv = d.createElement('div');
    const emptyScript = d.createElement('script');

    tagEl.className = 'oboxads';
    tagEl.setAttribute("data-section", section);
    if (options.hasOwnProperty('context')) {
      tagEl.setAttribute("data-context", options.context);
    } //if
    
    tagEl.appendChild(emptyDiv);
    tagEl.appendChild(emptyScript);

    if (options.hasOwnProperty('insertAfter') && options.insertAfter) {
      targetEl.parentNode.insertBefore(tagEl, targetEl.nextSibling)
    }
    else { 
      targetEl.appendChild(tagEl);
    } //if
    w.setTimeout(delayedAddBanner, 0);
  };

}();

/**
 * Sets page level targeting, this method needs be called before ad calls are made
 *
 * this method is called by OBOXADS.fn.init()
 *
 * @memberof OBOXADS.fn
 */
OBOXADS.fn.initTargeting = function () {
  /**
   * Event fired when about to set page targeting
   *
   * @memberof OBOXADS
   * @event beforeInitTargeting
   * @type {object}
   */
  OBOXADS.fn.emit('beforeInitTargeting');
  googletag.cmd.push(function() {
    var i, len, k, custom,
      vars = OBOXADS.vars,
      keys = [
        'subAdUnit','gender', 'age', 'ageGroup',
        'uniqueId', 'referrer', 'site',
        'keywords', 'lang', 'contentType',
        "custom", "custom2", "custom3", 
        "dailyBannerView", "affiliateId", "adMode",
        "utmCampaign", "utmSource", "utmMedium",
        "utmTerm", "utmContent","contentGroup"
      ],
      pubads = googletag.pubads();

    for (i = 0, len = keys.length; i < len; i++) {
      k = keys[i];
      if (typeof vars[k] !== 'undefined') {
        pubads.setTargeting(k.toLowerCase(), ""+ vars[k]);
      } //if

      pubads.setTargeting("contentcategories", Object.keys(vars.contentCategories));
    } //for
  });
};

!function () {
  OBOXADS.vars.addons.impactContentAds = OBOXADS.vars.addons.impactContentAds || {};
  let impactContentAds = OBOXADS.vars.addons.impactContentAds;
  impactContentAds.showAds = true;

  const insertionDivId = "slimcut_outstream_1";
  let contentAdDiv;
  let backfillRan = false;
  let contentAdInserted = false;
  let isLoaded = false;

  /*
   * Hides any outstream stuff and replaces it with an in content ad
   */
  const insertContentAd = () => {
    if (contentAdDiv && !contentAdInserted) {
      contentAdInserted = true;
      OBOXADS.fn.appendTag(contentAdDiv, 'content', {insertAfter: false, context: 'inserted-ad'});
      const outstreamDiv = document.getElementById(insertionDivId);
      if (outstreamDiv) {
        outstreamDiv.style.display = 'none';
      } //if
    } // if
  };
  
  /*
   * Validates if a node qualifies as a place to insert outstream
   */
  const validateNode = (node) => {
    return node.nodeName === 'P' || node.nodeName === '#text'
  }

  addCSS(`
    .oboxads-outstream {
      width: 100%;
      margin-bottom: 5px;
      padding: 10px;
      height: 385px;
    }

    .oboxads-outstream .oboxads {
      margin-top: 35px;
      min-width: auto !important;
    }

    .oboxads-outstream .oboxads>div {
      background: #efefef;
      min-width: 300px;
      min-height: 250px;
    }

    #slimcut_outstream_1 {
      width: 100%;
      border-radius: 2px;
      max-width: 630px;
      height: 360px;
      margin: 0 auto 0 auto;
    }

    #slimcut_outstream_1 {
      background: #efefef !important;
    }
  `);



  OBOXADS.fn.on('loaded', function() {

    if(!isLoaded){
      isLoaded = true;
    const contentEl = document.querySelector('.entry-content');
    const wordsBeforeOutstream = 35; // how many words between each banner
    const wordsAfterOutstream = 20; // how many words needed after last banner
      
    if (contentEl && OBOXADS.vars.showAds && impactContentAds.showAds) {

      const nodes = Array.prototype.slice.call(contentEl.childNodes);
      let wordCount = 0;
      let insertionPoint = null;

      for(let i = 0, len = nodes.length; i < len; i++) {
        wordCount += nodes[i].textContent.split(' ').length;
        if (insertionPoint === null && wordCount >= wordsBeforeOutstream && validateNode(nodes[i])) {
          log(`Found insertion point at node ${i+1} out of ${len}`);
          insertionPoint = nodes[i];
          wordCount = 0;
        } //if
      }

      if (insertionPoint !== null && wordCount >= wordsAfterOutstream) {
        contentAdDiv = document.createElement('div');

        contentAdDiv.className = 'oboxads-outstream';
        contentAdDiv.innerHTML = `
          <div id="${insertionDivId}"></div>
        `;

        insertionPoint.parentNode.insertBefore(contentAdDiv, insertionPoint.nextSibling);
      } else {
        log(`Could not find a valid insertion point wordsBeforeOutstream: ${wordsBeforeOutstream} wordsAfterOutstream: ${wordsAfterOutstream} wordCount:  ${wordCount} insertionPoint:`, insertionPoint);
      } //if

    } else {
      log(`Could not find contentEl (${contentEl})or ads disabled`);
    } // if

  }
  });

  OBOXADS.fn.on('passback:outstream-leave-behind', (e) => {
   insertContentAd(); 
  });

  OBOXADS.fn.on('passback:outstream-backfill', (e) => {
    const elements = document.getElementsByClassName('entry-content');

    insertContentAd(); 
    // disabled for now
    if (false && !backfillRan && elements.length > 0) {
      const taboola = OBOXADS.vars.addons.taboola;
      backfillRan = true;
      let div = document.createElement('div');

      elements[0].appendChild(div);

      taboola.replaceTag({
        mode: 'thumbnails-a',
        container: 'taboola-above-nav-3x1',
        placement: 'Above Nav 3x1',
        target_type: 'mix'
      }, {el: div});
    } //if
    
  });
  /* |------ Passback Slimcut End -------| */
}();

!function () {
  OBOXADS.fn.on('slotReady', ({slotName, tagInfo}) => {
    tagInfo.status = TagInfo.STATUS_READY;
    /**
     * Event fired when a banner is ready to be displayed
     *
     * Typically this means that banner has been added and that the slot is ready
     *
     * @memberof OBOXADS
     * @event bannerReady
     * @type {object}
     */
    OBOXADS.fn.emit('bannerReady', {slotName, tagInfo})
  });
}();

!function () {
  const bannersAtOnce = 4;
  let readyBuffer = [];
  let waitCount = 0;
  let intervalTimerId = null;
  let timeoutTimerId = null;
  
  const showBuffer = function () {
    // only show a new batch if we are not waiting for ad server
    if (waitCount <= 0) {
      let slotsToShow = readyBuffer.splice(0,bannersAtOnce);

      if (slotsToShow.length > 0) {
        OBOXADS.fn.showBanners(slotsToShow);
        // keep track of how many banners are loading
        waitCount += slotsToShow.length;
      }

      if (intervalTimerId !== null) {
        w.clearInterval(intervalTimerId);
        intervalTimerId = null;
      } //if

      if (timeoutTimerId !== null) {
        w.clearTimeout(timeoutTimerId);
        timeoutTimerId = null;
      } //if
    } else if (intervalTimerId) {
      // keep checking every 300ms
      intervalTimerId = w.setInterval(showBuffer, 1000);
    } //if
  };

  // track when banners are returned from the ad server
  OBOXADS.fn.on('bannerLoaded', ({slotName}) => {
    if (waitCount <= 1) {
      waitCount = 0;
      showBuffer();
    } else {
      waitCount--;
    } //if
  });

  OBOXADS.fn.on('bannerReady', ({slotName}) => {
    // group ready banners in a queue until we have enough to show
    readyBuffer.push(slotName);
    if (readyBuffer.length >= bannersAtOnce) {
      showBuffer(); 
    } else if (timeoutTimerId === null) {
      // force show the buffer after 300ms
      timeoutTimerId = w.setTimeout(showBuffer, 300);
    } //if
  });

}();

(function () {
  OBOXADS.vars.addons.special = OBOXADS.vars.addons.special || {};
  let specialVars = OBOXADS.vars.addons.special;
  specialVars.hideTimeout = 11000;

    OBOXADS.fn.on('libReady:gpt', function() {
      
      var addedCSS = false,
          setClass = function (el, newClass) {
            log('OBOXADS setting class:', newClass);
            var classes = el.className.split(' ').filter(function (curClass) {
                return (curClass == '' || curClass == 'slideIn' || curClass == 'slideOut') ?  false : true;
            });

            classes.push(newClass);

            el.className = classes.join(' ');
        };

        googletag.pubads().addEventListener('slotRenderEnded', function (e) {
          var elementId = e.slot.getSlotElementId();

            if ( elementId.indexOf('oboxads-special') >= 0 && e.size[1] > 5) {

                var special = d.getElementById(elementId);
                setClass(special, 'slideIn');
                var closeLeft = (e.size[0]) - 10;

                if (!addedCSS) {
                  log('OBXADS added css');
                  addedCSS = true;
                  addCSS([
                    '.slideIn {',
                    '    animation-duration: 4s;',
                    '    animation-name: slidein;',
                    '}',

                    '.closeWrapper {',
                    '    width: '+ e.size[0] +'px;',
                    '    position: relative;',
                    '    bottom: 0;',
                    '    z-index: 2999999;',
                    '    left: 0;',
                    '    margin: auto;',
                    '    height: 0',
                    '}',

                    '.oboxads-special {',
                    '    width:  ' + e.size[0] + 'px;',
                    '    height:  ' + e.size[1] + 'px;',
                    '    position: fixed;',
                    '    bottom: 0;',
                    '    z-index: 9999999;',
                    '    left: 50%;',
                    '    margin-left: -' + (e.size[0] /2) + 'px !important;',
                    '}',

                    '.oboxads-special a.obx-close {',
                    '    display: block;',
                    '    position: relative;',
                    '    top: -10px;',
                    '    left: '+ (e.size[0] - 10) +'px;',
                    '    height: 20px;',
                    '    width: 20px;',
                    '    background:  url(data:image/png;base64,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) no-repeat;',
                    '    background-size: 100%;',
                    '}',
                    '@media (max-width: 728px) {',

                    '    .oboxads-special a.obx-close {',
                    '      left: '+ (e.size[0] - 8) +'px;',
                    '      height: 25px;',
                    '      width: 25px;',
                    '    }',
                    '}',

                    '@media (max-width: 480px) {',

                    '    .oboxads-special a.obx-close {',
                    '        height: 30px;',
                    '        width: 30px;',
                    '    }',
                    '}',

                    '@keyframes slidein {',
                    '    0%,70% { transform: translateY(250%); }',
                    '    100% { transform: translateY(0%); }',
                    '}',

                    '@-webkit-keyframes slidein {',
                    '    0%,70% { -webkit-transform: translateY(250%); -ms-transform: translateY(250%);}',
                    '    100% { -webkit-transform: translateY(0%); -ms-transform: translateY(0%); }',
                    '}',

                    '@keyframes slideOut {',
                    '    0% { transform: translateY(0); }',
                    '    99% { transform: translateY('+(e.size[1]+20)+'px);  }',
                    '   100% {',
                    '		visibility:hidden;',
                    '		opacity: 0;',
                    ' 	}',
                    '}',

                    '@-webkit-keyframes slideOut {',
                    '   0% { -webkit-transform: translateY(0); -ms-transform: translateY(0); }',
                    '   99% { -webkit-transform: translateY('+(e.size[1]+20)+'); -ms-transform: translateY('+(e.size[1]+20)+'); }',
                    '   100% {',
                    '		  visibility:hidden;',
                    '		  opacity: 0;',
                    ' 	}',
                    '}',

                    '.slideOut {',
                    ' 	 opacity: 1;',
                    '	   animation-duration: 3s;',
                    '    animation-name: slideOut;',
                    '    height: 0;',
                    '	   -webkit-animation-fill-mode: forwards;',
                    '	   -ms-animation-fill-mode: forwards;',
                    '}'
                  ].join("\n"));
                } //if
                var specialTemplate = [
                  '<div class="closeWrapper">',
                  '    <a href="#" class="obx-close"></a>',
                  '</div>'
            ].join("\n");
            special.insertAdjacentHTML('afterbegin', specialTemplate);

            var toggleFlag = 'false';
            var toggleSlide = function(){
                if (toggleFlag === 'false') {
                    toggleFlag = 'true';
                    // hide special
                    setClass(special, 'slideOut');
                    // hide special container element
                    setClass(special.closest(".oboxads-special"), 'slideOut');
                    console.log("slideout");
                } else {
                    toggleFlag = 'false';
                    log('Special already been closed.');
                    return false;
                }
            }

            setTimeout(function() {
                toggleSlide()
            }, specialVars.hideTimeout);

            var closeBtn = document.getElementsByClassName('obx-close')[0];
            closeBtn.addEventListener('click', function(e) {
                e.preventDefault();
		              log('Special has been clicked!');
                toggleSlide();
            });   
            }
        });

    });

})();

!function () {
    OBOXADS.vars.addons.gallery = OBOXADS.vars.addons.gallery || {};
    OBOXADS.vars.addons.gallery.banners = OBOXADS.vars.addons.gallery.banners || [];
    var galleryBanners = OBOXADS.vars.addons.gallery.banners;

    OBOXADS.fn.on('initGallery',function (e) {

        var gallery = e.gallery,
            specialTimeout = OBOXADS.vars.adMode === 'acq' ? 2500 : 7000,
            lastUpdate = new Date().getTime(),
            refreshSpecial = false,
            specialClear = function () {
                log('Resetting Catfish Flag');
                refreshSpecial = true;
            },
            specialTimer = function () {
                refreshSpecial = false;
                setTimeout(specialClear, specialTimeout);
            },
            uniqueArr = function(arr) {
              var seen = {};
              return arr.filter(function (item) {
                if (seen.hasOwnProperty(item)) {
                  return false;
                } //if

                seen[item] = true;
                return true;
              });
            },
            bannerFilter = function(banner) {
              var el;
              if (banner.indexOf('special') === -1) {
                return true;
              } else if (refreshSpecial) {
                el = d.getElementById('oboxads-'+ banner);
                if (el && el.className.indexOf("slideOut") >= 0) {
                  log('Reloading Catfish');
                  specialTimer();
                  return true;
                } 
              } //if

              return false;
            };

        specialTimer();

        gallery.listen('afterChange', function() {
            var bannersToLoad = [],
                currentTime = new Date().getTime();
            if (galleryBanners.length > 0 && (currentTime - lastUpdate) > 2500) {
                lastUpdate = currentTime;
                bannersToLoad = uniqueArr(galleryBanners).filter(bannerFilter);
                log('OBOXADS Reloading banner: ', bannersToLoad);

                if (bannersToLoad.length > 0) {
                  OBOXADS.fn.refreshBanners(bannersToLoad);
                } //if
            } //if
        });
    });
}();

/**
 * Registers an element to follow screen on scroll
 *
 * @memberof OBOXADS.fn
 *
 * @param {object} params - settings for the scrolling behavior
 * @param {DOMElement} params.parentEl - container for the element will define bounds for the scroll area
 * @param {DOMElement} params.el - element to scroll
 * @param {number} params.paddingTop - number of pixels to add at the top for padding
 *
 */
OBOXADS.fn.bannerScroll = function (params) {
        
    OBOXADS.fn.domReady(function () {
        var scrollHandler, resizeHandler, resetBanner, $ = jQuery, set = false,
            minTop = 1000000, maxTop = 1000000, 
            originalLeft = 0, originalWidth = 0,
            parentEl = params.parentEl || null, 
            targetEl = $(params.el).last(),
            paddingTop = params.paddingTop || 0;

        if (targetEl && targetEl.length <= 0) {
            return;
        } //if

        if (parentEl) {
            parentEl = $(targetEl).parents(parentEl).eq(0);
        } //if


        resizeHandler = function () {
            targetEl.css({"position": "static", "top": "auto", "width": "auto"});
            minTop = 1000000;
            set = false;
            log('resize');
        };

        scrollHandler = function() {
            var windowTop = $(w).scrollTop(), // pixels hidden above scroll
                newMinTop= targetEl.offset().top;

            if (minTop > newMinTop) {
                minTop = newMinTop;
                originalLeft = targetEl.offset().left;
                originalWidth = targetEl.width();
                if (parentEl) {
                    maxTop = parentEl.offset().top + parentEl.height() - targetEl.height() - paddingTop - paddingTop;
                } //if
                log('minTop:', minTop, 'maxTop:', maxTop);
            } //if

            if ( windowTop > maxTop ) {
                if (set) {
                    log('stopped');
                    targetEl.css({"position": "relative", "top": (windowTop - minTop) + "px", "left": "auto"});
                    set = false;
                } //if
            } else if ( minTop > 0 && windowTop > minTop) {
                if (!set) {
                    log('set');
                    targetEl.css({"position": "fixed", "top": paddingTop +"px", "width": originalWidth +"px"});
                    set = true;
                } //if
            } else if (set) {
                log('unset');
                targetEl.css({"position": "static"});
                set = false;
            } //if
        };

        OBOXADS.fn.addEvent(w, 'scroll', scrollHandler);        
        OBOXADS.fn.addEvent(w, 'load', resizeHandler);        
        OBOXADS.fn.addEvent(w, 'resize', resizeHandler);        

    });
};

/*
  !function(a,l,b,c,k,s,t,g,A){a.CustomerConnectAnalytics=k,a[k]=a[k]||function(){
    (a[k].q=a[k].q||[]).push(arguments)},t=t||"",g=l.createElement(b),A=l.getElementsByTagName(b)[0],
      g.type="text/javascript",g.defer=!0,g.async=!0,g.src=c+"?id="+s+"&parentId="+t+"&nct="+(new Date().getTime()),A.parentNode.insertBefore(g,A)
  }(window,document,"script","//analytics.ccgateway.net/script","cca","{%clickscoDomain%}","obox-media");

!function(a,l,b,c,k,s,t,g,A){a.CustomerConnectAnalytics=k,a[k]=a[k]|| function(){
  (a[k].q=a[k].q||[]).push(arguments)},g=l.createElement(b),A=l.getElementsByTagName(b)[0],
    g.type="text/javascript",g.defer=!0,g.async=!0,g.src=c+"?id="+s+"&parentId="+t+"&nct="+(new Date().getTime()),A.parentNode.insertBefore(g,A)
  }(window,document,"script","//analytics.ccgateway.net/script","cca","{%clickscoDomain%}", "66dc95b4");

*/

!function(a,l,b,c,k,s,t,g,A){a.CustomerConnectAnalytics=k,a[k]=a[k]||function(){
  (a[k].q=a[k].q||[]).push(arguments)},g=l.createElement(b),A=l.getElementsByTagName(b)[0],
    g.type="text/javascript",g.async=!0,g.src=c+"?id="+s+"&parentId="+t,A.parentNode.insertBefore(g,A)
}(window,document,"script","//carbon-cdn.ccgateway.net/script","cca",window.location.hostname,"dc4aba8178");

OBOXADS.fn.on('beforeInitLoop', function (e) {
  let acqParam = '';
  const vars = OBOXADS.vars;
  const acqSessionStorage = !!true
  const setAcq = function (value) {
    if (acqSessionStorage) {
      sessionStorage.setItem('obox_acq', value);
    } else {
      OBOXADS.fn.addCookie('obox_acq', value);
    }
  };

  const readAcq = function () {
    if (acqSessionStorage) {
      return sessionStorage.getItem('obox_acq') || "";
    } else {
      return OBOXADS.fn.readCookie('obox_acq') || "";
    }
  };

  // first check if utm_content has acq- value
  if (vars.urlParams.hasOwnProperty('utm_content')
    && vars.urlParams['utm_content'].indexOf('acq-') !== -1) {
    acqParam = vars.urlParams['utm_content'];
    setAcq(acqParam);
  } else {
    acqParam = readAcq();
  } //if

  log('ACQ Param:', acqParam);
  // turn on acq mode if parameter detected
  if (acqParam.indexOf('acq-') === 0) {
    vars.adMode = "acq";
    let provider = acqParam.split('-').pop();

    if (!!true) {
      switch(provider) {
        case "fb":
        case "tab":
        case "rev":
          vars.site += `/acq/${provider}/`;
          break;
        default:
          vars.site += '/acq/other_src/';
      }
    } //if
  } //if


});

!function () {
  OBOXADS.vars.addons.taboola = OBOXADS.vars.addons.taboola || {};
  const taboola = OBOXADS.vars.addons.taboola;

  let taboolaOn = false;

  // This way it will only activate once. on the first activation of the 
  // Taboola event.
  function insertTaboola(){
    if(taboolaOn) return;
      taboolaOn = true;


    const taboolaSrc = "psquaredinc-network";
    const taboolaPush =  null||{photo:"auto"}
    //Place this code in the <head> section:
    window._taboola = window._taboola || [];
    _taboola.push(taboolaPush);
    !function (e, f, u, i) {
      if (!document.getElementById(i)){
        e.async = 1;
        e.src = u;
        e.id = i;
        f.parentNode.insertBefore(e, f);
      }
    }(document.createElement('script'),
      document.getElementsByTagName('script')[0],
      `//cdn.taboola.com/libtrc/${taboolaSrc}/loader.js`,
      'tb_loader_script');
    if(window.performance && typeof window.performance.mark == 'function')
    {window.performance.mark('tbl_ic');}

  }

  let seenTags = {};

  taboola.replaceTag = function (tagConfig, event) {
    event.preventDefault = true;
    insertTaboola();
    if (!seenTags.hasOwnProperty(tagConfig.container)) {
      seenTags[tagConfig.container] = true;
      event.el.id = tagConfig.container;

      _taboola.push(tagConfig);
    } //if
  };
  
  taboola.flush = function () {
    _taboola.push({flush: true});
  };


}();

(function () {

  OBOXADS.vars.addons.nativemix = OBOXADS.vars.addons.nativemix || {};

  OBOXADS.vars.addons.nativemix = {

    /*AUTOCOLLAPSE*/
    maxCheck: 40,
    OBOXADS: 0,
    currentCheck: 0,
    hasOneAd: false,

    init: function () {
      var _this = OBOXADS.vars.addons.nativemix;
      _this.createNativeProgrammatic();
    },


    /*ADDING ELEMENT AFTER SPÉCIAL BLOCK*/
    createNativeProgrammatic: function () {

      var _this = OBOXADS.vars.addons.nativemix;

      var widget = document.querySelector(".content-widget-wrapper");

      if (widget) {

        /*Creating container*/
        var blockNativeProg = document.createElement("div");
        blockNativeProg.setAttribute("id", "blockNativeProg");
        blockNativeProg.setAttribute("class", "cssAnim");

        // Creating BlockNativeProg inner
        var blockNativeProgInner = document.createElement("div");
        blockNativeProgInner.setAttribute("class", "blockNativeProgInner clearfix");

        // Creationg BlockNative title block
        var blockNativeTitle = document.createElement("div");
        blockNativeTitle.setAttribute("class", "block-native-title clearfix");

        // Creating two section add block container for HPQ
        var blockContainer1 = document.createElement("div");
        blockContainer1.setAttribute("class", "native-block native-block-1");
        var blockContainer2 = document.createElement("div");
        blockContainer2.setAttribute("class", "native-block native-block-2");

        // Creating title sections
        var titleLeft = document.createElement("div");
        titleLeft.setAttribute("class", "titleLeft");
        titleLeft.innerHTML = "À DÉCOUVRIR AUSSI";
        var titleRight = document.createElement("div");
        titleRight.setAttribute("class", "titleRight");
        titleRight.innerHTML = "Contenus sponsorisés";


        // Apprend Elements
        blockNativeTitle.appendChild(titleLeft);
        blockNativeTitle.appendChild(titleRight);
        blockNativeProgInner.appendChild(blockNativeTitle);
        blockNativeProgInner.appendChild(blockContainer1);
        blockNativeProgInner.appendChild(blockContainer2);
        blockNativeProg.appendChild(blockNativeProgInner);

        // blockNativeProg.innerHTML = containerNAtive;
        widget.parentNode.insertBefore(blockNativeProg, widget.nextSibling);

        // Adding CsSS
        addCSS([

          '#blockNativeProg {',
          '    position: relative;',
          '    display: block;',
          '    float: left;',
          '    background-color: #e7e7e7;',
          '    width: 100%;',
          '    margin-bottom: 30px;',
          '}',

          '.blockNativeProgInner {',
          '    width: 100%;',
          '    padding: 10px 0 0 0;',
          '    position: relative;',
          '    display: block;',
          '    margin: 0 auto;',
          '}',

          '.blockNativeProgInnerOne {',
          '    max-width: 700px;',
          '}',


          '.blockNativeProgInner.mobile-inner {',
          '    max-width:400px;',
          '}',


          '#blockNativeProg .blockNativeProgInner .oboxads{',
          '    width: 100%;',
          '}',

          '#blockNativeProg .blockNativeProgInner .native-block{',
          '    width: 50%;',
          '    display: inline-block;',
          '    max-height: 320px;',
          '    overflow: hidden;',
          '    float: left;',
          '    padding: 5px;',
          '}',

          '#blockNativeProg .blockNativeProgInner.mobile-inner .native-block{',
          '    width: 100%;',
          '}',

          '#blockNativeProg .blockNativeProgInner .native-block.full-size-one {',
          '    width: 100%;',
          '    float: none;',
          '}',

          '#blockNativeProg .blockNativeProgInner .block-native-title {',
          '    padding:  0 5px;',
          '}',

          '#blockNativeProg .blockNativeProgInner .block-native-title .titleLeft {',
          '    font-size:   1.35em;',
          '    float:  left;',
          '    font-family: Fjalla One,sans-serif;',
          '    font-weight: 400;',
          '}',

          '#blockNativeProg .blockNativeProgInner .block-native-title .titleRight {',
          '    font-size:   0.85em;',
          '    float:  right;',
          '    font-weight: 400;',
          '}'
        ].join("\n"));

        // Append ad tag to ads blocks 
        OBOXADS.fn.appendTag(document.querySelector("#blockNativeProg .blockNativeProgInner .native-block-1"), "content", { context: 'oboxfluidmix' });
        OBOXADS.fn.appendTag(document.querySelector("#blockNativeProg .blockNativeProgInner .native-block-2"), "content", { context: 'oboxfluidmix' });

        console.log("--------- creative bloc native prog -------");

        _this.verifyAdHeight();
      }
      else {
        setTimeout(_this.createNativeProgrammatic, 200);
      }
    },


    /*CHECK IF ELEMENT IS FULLY IN VIEW PORT*/
    elementInViewport: function (el) {  //CJ reused code
      var top = el.offsetTop;
      var left = el.offsetLeft;
      var width = el.offsetWidth;
      var height = el.offsetHeight;

      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }

      return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        (top + height) <= (window.pageYOffset + window.innerHeight) &&
        (left + width) <= (window.pageXOffset + window.innerWidth)
      );
    },

    ajustAdSize: function () {

      console.log("ajustAdSize");

      if (document.documentElement.offsetWidth >= 778) {
        document.querySelector("#blockNativeProg .blockNativeProgInner").classList.remove("mobile-inner");
      }
      else {
        document.querySelector("#blockNativeProg .blockNativeProgInner").classList.add("mobile-inner");
      }
    },

    ajustOneAdSize: function () {

      var adIframe = document.querySelector("#blockNativeProg iframe");

      if (document.documentElement.offsetWidth >= 778) {
        document.querySelector("#blockNativeProg .blockNativeProgInner").classList.remove("mobile-inner");
      }


      if (adIframe.offsetWidth >= 600) {
        // adIframe.style.maxHeight = "175px";
      }
      else {
        adIframe.style.maxHeight = "";
        document.querySelector("#blockNativeProg .blockNativeProgInner").classList.add("mobile-inner");
      }

    },

    verifyAdHeight: function () { //CJ reused code
      var _this = OBOXADS.vars.addons.nativemix;
      var checkHeight = document.querySelectorAll("#blockNativeProg iframe");
      var NoAdDisplayed = 0;
      var elmentsWithAd = [];

      /*Only check if element is in viewport*/
      if (!_this.elementInViewport(document.getElementById("blockNativeProg"))) {
        setTimeout(_this.verifyAdHeight, 200);
        return false;
      }

      if (checkHeight.length > 0) {

        for (var i = 0; i < checkHeight.length; i++) {

          if (Number(checkHeight[i].height) < 10) {
            console.log("not displayed");
            NoAdDisplayed++;
          }// end if

        }// end for

        //if all ad unit empty, then the block is eligible for autocollapse*/
        if (checkHeight.length > 0) {
          _this.currentCheck++;
          if (_this.currentCheck >= _this.maxCheck) {

            if (NoAdDisplayed !== 0) { // make bloc full size if only one ad loaded


              for (var i = 0; i < checkHeight.length; i++) {
                if (Number(checkHeight[i].height) > 10) {
                  checkHeight[i].closest(".native-block").classList.add("full-size-one");
                  document.querySelector("#blockNativeProg .blockNativeProgInner").classList.add("blockNativeProgInnerOne");
                  document.querySelector("#blockNativeProg .blockNativeProgInner iframe").style.height = "";
                  document.querySelector("#blockNativeProg .blockNativeProgInner iframe").style.maxHeight = "";
                  _this.hasOneAd = true;
                  _this.ajustOneAdSize();
                  window.onresize = function () {
                    _this.ajustOneAdSize()
                  }

                  /*window.addEventListener('resize', function (event) {
                    OBOXADS.vars.addons.nativemix.ajustOneAdSize();
                  });*/
                }//
                else {
                  checkHeight[i].closest(".native-block").style.display = "none";
                }
              }
            }
            else { // Hide if element no ads loaded 

              if (NoAdDisplayed === 2) {
                var allBlock = document.querySelector("#blockNativeProg");
                allBlock.style.height = "0px";
                setTimeout(function () {
                  allBlock.style.display = "none";
                }, 600);
              }

            }


          } else {
            setTimeout(_this.verifyAdHeight, 200);
          }// end else if

        }// end if

      } else {

        OBOXADS.vars.addons.nativemix.ajustAdSize();

        window.onresize = function () {
          OBOXADS.vars.addons.nativemix.ajustAdSize();
        }

        setTimeout(_this.verifyAdHeight, 200);
      }// end else if

    },

  }
  setTimeout(OBOXADS.vars.addons.nativemix.init, 100);
}());
(function () {

    OBOXADS.vars.addons.gdproath = OBOXADS.vars.addons.gdproath || {};

    OBOXADS.vars.addons.gdproath = {
        continent: {
            code: null
        },
        init: function () {
            var _this = OBOXADS.vars.addons.gdproath;
            console.log("OBOXADS.vars.addons.gdproath");

            OBOXADS.fn.on('loaded', function () {

                if (typeof OBOXADS.vars.urlParams.continent !== 'undefined' && OBOXADS.vars.urlParams.continent.toLowerCase() === "eu") {
                    _this.initCmp();
                } else if (OBOXADS.fn.readCookie("euconsent") === null) {
                    try {
                        var xmlhttp = new XMLHttpRequest();
                        var url = "https://api.userinfo.io/userinfos";

                        xmlhttp.onreadystatechange = function () {
                            if (this.readyState == 4 && this.status == 200) {
                                var data = JSON.parse(this.responseText);

                                OBOXADS.vars.addons.gdproath.continent.code = data.continent.code;

                                if (OBOXADS.vars.addons.gdproath.continent.code === 'EU') {
                                    // init cmp
                                    _this.initCmp();
                                }

                                //console.log("Continent: " + OBOXADS.vars.addons.gdproath.continent.code);
                            }
                        };
                        xmlhttp.open("GET", url, true);
                        xmlhttp.send();

                    } catch (err) {
                        console.log(err);
                    }
                }
            });

            OBOXADS.fn.on('libInit:gpt', function () {

                if (OBOXADS.vars.addons.gdproath.continent.code === 'EU' || OBOXADS.fn.readCookie("euconsent") !== null) {
                    // Serve non-personalized ads (DFP)
                    //console.log('Serve Non Personlized Ads');
                    googletag.pubads().setRequestNonPersonalizedAds(1);
                }
            });

        },

        initCmp: function () {
            if (!window.__cmp) {
                window.__cmp = (function () {
                    var listen = window.attachEvent || window.addEventListener;
                    listen('message', function (event) {
                        window.__cmp.receiveMessage(event);
                    }, false);

                    function addLocatorFrame() {
                        if (!window.frames['__cmpLocator']) {
                            if (document.body) {
                                var frame = document.createElement('iframe');
                                frame.style.display = 'none';
                                frame.name = '__cmpLocator';
                                document.body.appendChild(frame);
                            } else {
                                setTimeout(addLocatorFrame, 5);
                            }
                        }
                    }
                    addLocatorFrame();

                    var commandQueue = [];
                    var cmp = function (command, parameter, callback) {
                        if (command === 'ping') {
                            if (callback) {
                                callback({
                                    gdprAppliesGlobally: !!(window.__cmp && window.__cmp.config && window.__cmp.config.storeConsentGlobally),
                                    cmpLoaded: false
                                });
                            }
                        } else {
                            commandQueue.push({
                                command: command,
                                parameter: parameter,
                                callback: callback
                            });
                        }
                    }
                    cmp.commandQueue = commandQueue;
                    cmp.receiveMessage = function (event) {
                        var data = event && event.data && event.data.__cmpCall;
                        if (data) {
                            commandQueue.push({
                                callId: data.callId,
                                command: data.command,
                                parameter: data.parameter,
                                event: event
                            });
                        }
                    };
                    cmp.config = {
                        //
                        // Modify config values here
                        //
                        globalVendorListLocation: document.location.origin + '/pubvendors.json',
                        customPurposeListLocation: document.location.origin + '/pubvendors.json',
                        //  globalConsentLocation: 'https://api.oboxmedia.com/cmp/portal.html',
                        storeConsentGlobally: false,
                        storePublisherData: true,
                        // logging: 'debug',
                        // localization: {},
                        // forceLocale: 'en-us'
                    }
                    return cmp;
                }());
                var t = document.createElement('script');
                t.async = false;
                t.src = "https://api.oboxmedia.com/cmp/cmp.bundle.js";
                var tag = document.getElementsByTagName('head')[0];
                tag.appendChild(t);

                //Show consent tool only if user has not already respond 
                window.__cmp('showConsentTool', null, function (result) {

                    // Loading scripts
                    OBOXADS.vars.addons.gdproath.addExtraCss();
                    OBOXADS.vars.addons.gdproath.addExtraJS();

                });
            }

        },

        addExtraCss: function () {
            var divExtraCSS = document.createElement("style");
            divExtraCSS.innerHTML = ".banner_banner--3pjXd{z-index: 99999999;} .popup_popup--1TXMW{z-index: 9999999999;} @media only screen and (min-device-width:128px) and (max-device-width:480px){ .popup_popup--1TXMW{z-index:9999999999999} .banner_banner--3pjXd{align-items:inherit!important;justify-content:inherit!important;word-break:break-word!important;max-height:350px;overflow:scroll;bottom:0!important}.banner_info--2XcOt{display:block!important}.banner_infoExpanded--1AHSZ{padding-bottom:50px!important}div.vendors_vendors--8OdK0 table tr td,div.vendors_vendors--8OdK0 table tr th{white-space:inherit} .details_details--3oWod .details_save--1ja7w {padding-top:5px;}}";

            if (document.body !== null)
                document.body.appendChild(divExtraCSS);
            else
                document.head.appendChild(divExtraCSS);
        },

        addExtraJS: function () {
            if (window.matchMedia("(max-width: 480px)").matches) {
                var blockText = document.querySelector(".banner_info--2XcOt");
                var br1 = document.createElement('br');
                blockText.insertBefore(br1, blockText.querySelectorAll("a")[1]);
                var br2 = document.createElement('br');
                blockText.insertBefore(br2, blockText.querySelectorAll("a")[2]);

                // Fixing the click issue to close popup
                document.querySelector(".banner_info--2XcOt a:nth-of-type(3)").onclick = function () {
                    document.querySelector(".banner_banner--3pjXd").style.display = "none";
                };
                document.querySelector('.app_gdpr--2k2uB a:nth-last-child(1)').onclick = function () { document.querySelector('.app_gdpr--2k2uB').style.display = "none"; }
            }
        }
    };

    OBOXADS.vars.addons.gdproath.init();

}());
!function () {
  OBOXADS.vars.addons.staticAdsense = OBOXADS.vars.addons.staticAdsense || {};
  const staticAdsense = OBOXADS.vars.addons.staticAdsense;
  staticAdsense.showAds = true;

  let loaded = false;
  const registeredSlots = {};
  const slotsToTrack = [];
  staticAdsense.registerSlots = function(slots) {
    slots.forEach((slotConfig) => {
      registeredSlots[slotConfig.slotName] = slotConfig;
    });

    if (!loaded) {
      OBOXADS.fn.loadScript("//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js");
      loaded = true;
    } // if

  };

  const showAdSense = function (slotName) {
    if (!staticAdsense.showAds) {
      return;
    } // if

    if (!registeredSlots.hasOwnProperty(slotName)) {
      return;
    } // if

    const slotConfig = registeredSlots[slotName];
    if (!slotConfig.hasOwnProperty('sizes')) {
      return;
    } //if

    let adSenseSlotId;
    if ( slotConfig.hasOwnProperty('slotId') ) {
      adSenseSlotId = slotConfig.slotId;
    } else {
      switch(slotConfig.type) {
        case 'text':
          adSenseSlotId = "9023279486";
          break;
        case 'display':
          adSenseSlotId = "4945337634";
          break;
        default:
          adSenseSlotId = "4134818840";
          break;
      } // switch
    } //if

    const selector = `.oboxads-${slotName} ins`;
    let css = [];
    let responsiveHeight = true;

    slotConfig.sizes.forEach( ({resolution, size}) => {
     
      const [resolutionWidth, resolutionHeight] = resolution;
      const [width, height] = size;

      let cssRules = '';

      if (width > 0) {
        cssRules += `width: ${width}px;`;
      } //if

      if (height > 0) {
        cssRules += `height: ${height}px; max-height: ${height}px;`;
        responsiveHeight = false;
      } //if

      if (resolutionWidth === 0 && resolutionHeight === 0) {
        css.push(`${selector} { ${cssRules} }`);
      } else if (resolutionHeight === 0) {
        css.push(`@media(min-width: ${resolutionWidth}px) { ${selector} { ${cssRules} } };`);
      } else {
        css.push(`@media(min-width: ${resolutionWidth}px) and (min-height: ${resolutionHeight}px) { ${selector} { ${cssRules} } };`);
      } // if
    });
      
    addCSS(css.join("\n"));

    const adFormatAttribute = responsiveHeight ? 'data-ad-format="auto"' : '';

    slotConfig.el.innerHTML = `
    <ins class="adsbygoogle"
      style="display:block;"
      data-ad-client="ca-pub-8784410666981615"
      data-ad-slot="${adSenseSlotId}"
      ${adFormatAttribute}></ins>`;

    if (slotConfig.hasOwnProperty('height')) {
      heightStyle = `height: ${slotConfig.height};`;
    } else if (slotConfig.hasOwnProperty('width')) {
    } // if

    let currentAd = new AdInfo();
    currentAd.isEmpty = false;
    currentAd.description = 'Static Ad Sense';

    slotConfig.tagInfo.setCurrentAd(currentAd);

    if (OBOXADS.vars.addons.hasOwnProperty('adLabel')) {
      OBOXADS.vars.addons.adLabel.applyLabel(slotConfig.el);
    } //if
 
    w.setTimeout(function () {(window.adsbygoogle = window.adsbygoogle || []).push({});} , 0);
  };

  /* - listen for passback postMessage -
  OBOXADS.fn.addEvent(w,'message', (e) => {
    if (typeof e.data === 'object' && e.data.hasOwnProperty('type') && e.data.type === 'oboxads-passback-adsense') {
      log('Got Message', e.data);
      // redirect to desired ad...
      e.source.location = 'http://local.wp.oboxlabs.com/test.html';
    } //if
  });
  */

  OBOXADS.fn.on('bannerConfig', (e) => {
    const slotName = `${e.params.section}-${e.params.pos}`;
    if (registeredSlots.hasOwnProperty(slotName)) {
      const slotConfig = registeredSlots[slotName];
      slotConfig.el = e.el;
      slotConfig.tagInfo = e.tagInfo;
      OBOXADS.fn.monitorBanner(slotName);
      e.preventDefault = true;
    } //if
  });

  OBOXADS.fn.on('bannerDisabled',({params, tagInfo}) => {
  
    const slotName = `${params.section}-${params.pos}`;
    if (registeredSlots.hasOwnProperty(slotName)) {
      tagInfo.status = TagInfo.STATUS_CUSTOM;
      
    } // if
  });

  OBOXADS.fn.on('bannersInView', function ({banners}) {
    banners.forEach(showAdSense);
  });
}();

!function () {
  w['_ft'] = {"account": "100069.100637.102164"};
  OBOXADS.fn.loadScript('https://cdn.soko.ai/ft.min.js');
}();

!function () {
  addCSS(`
    .oboxads {
        display: table;
        text-align: center;
        margin: auto;
    }
  `);
}();

(function () {

  addCSS([
    '.gallery-wrapper .oboxads-content-native {',
    '    position: absolute;',
    '    bottom: 5px;',
    '}',

    '.oboxads-content-native > div {',
    '  width: 100%;',
    '  max-width: 390px;',
    '}',

    '.oboxads-side {',
    '  width: 100%;',
    '}',

    '.row .content-ad {',
    '  padding: 0;',
    '}',

    '.row .oboxads-content {',
    '  width: 100%;',
    '  max-width: 390px;',
    '}',

    '.row .oboxads-content > div{',
    '  margin: 0 auto;',
    '}',

    '.oboxads-content ins, .oboxads-side ins {',
    '  margin: 0 auto;',
    '}',

    'body .native-bottom-block.desktop .bottom-content-native{',
    '  width: 49%;',
    '}',
    'body .native-bottom-block.desktop .bottom-content-native.left{',
    '  margin-right: 1%;',
    '}',

    'body .native-bottom-block.mobile {',
    '  margin: 0 -10px;',
    '}',

    'body .native-bottom-block.mobile .bottom-content-native{',
    '  width: 100%;',
    '}',

    'body .native-bottom-block .bottom-content-native {',
    '  float: left;',
    '}',

    'body .native-bottom-block .bottom-content-native .oboxads-content-contentnative {',
    '  width: 100%;',
    '}',

  ].join("\n"));

  /*
  |---------------------
  | Video Player Begin
  |---------------------
  */

  addCSS([
    '.entry-content-asset {',
    '    position: relative;',
    '    padding-bottom: 56.25%;',
    '    height: 0;',
    '    overflow: hidden;',
    '    max-width: 100%;',
    '}'
  ].join("\n"));

  const time = 2000;
  var timerCount = 0;
  const prerollAdUnit = 'https://pubads.g.doubleclick.net/gampad/ads?iu=/139271940/hollywoodpq>fr/preroll&description_url=http%3A%2F%2Fhollywoodpq.com&env=vp&impl=s&correlator=&tfcd=0&npa=0&gdfp_req=1&output=vast&sz=400x300|640x480&unviewed_position_start=1';


  OBOXADS.fn.on('loaded', function () {
    if (OBOXADS.vars.contentType === 'articles') {
      var detectedVideos = OBOXADS.fn.detectVideoPlayer(time, timerCount);
      OBOXADS.fn.initVideoPlayer(detectedVideos, prerollAdUnit);
    }
  });

  /* |------ Video Player Ends -------| */


  /*
  |------------------
  | Money Tag Begin
  |------------------
  */
  !function () {
    const parentEl = allScripts[0];
    const el = d.createElement('script');
    el.src = 'https://middycdn-a.akamaihd.net/bootstrap/moneytag.js';
    el.id = 'browsi-tag';
    el.setAttribute("data-pubKey", 'obox');
    el.setAttribute("data-siteKey", 'hollywoodpq');
    parentEl.parentNode.insertBefore(el, parentEl);
  }();
  /* |------ Money Tag End -------| */

  OBOXADS.fn.on('beforeInitTargeting', () => {
    var adUnit = '', subAdUnit = '';

    if (location.pathname === '/') {
      subAdUnit = 'homepage';
    } //if

    switch (OBOXADS.vars.contentType) {
      case 'homepage':
      case 'categories':
      case 'articles':
      case 'search':
      case 'contest':
      case 'quiz':
      case 'slideshow':
      case 'eshop':
        adUnit = OBOXADS.vars.contentType;
        break;
      case 'gallery':
      case 'galleries':
        adUnit = 'galleries';
        break;
      default: adUnit = 'other';
    }

    OBOXADS.vars.adUnit = adUnit;
    if (OBOXADS.vars.subAdUnit.length === 0 && subAdUnit.length > 0) {
      OBOXADS.vars.subAdUnit = subAdUnit;
    } else if (OBOXADS.vars.subAdUnit === 'od-bali') {
      // overrite site (which is base of the ad unit...
      OBOXADS.vars.site = 'hollywoodpq>fr/vtele/od' + (OBOXADS.vars.adMode === 'acq' ? '/acq' : '');
    } //if

    // activate portrait 300x1050
    slotAddSize('side-1', false, [17, 1], [300, 1050]);
    slotAddSize('side-1', tabletSize, [300, 1050]);
    slotRemoveSize('header-1', mobileSize, false, [300, 250]);
    slotAddSize('header-1', mobileSize, [320, 50]);

    slotSettings["header-1"] = {
      "defaultSizes": [[728, 90], [970, 125], [970, 250], [970, 90], [970, 500]],
      "mapping": [
        { "resolution": desktopSize, "sizes": [[728, 90], [970, 125], [970, 250], [970, 90], [970, 500]] },
        { "resolution": tabletSize, "sizes": [[728, 90]] },
        { "resolution": mobileSize, "sizes": [[320, 50], [300, 50]] }
      ]
    };

    slotRemoveSize('content-oboxfluidmix', desktopSize, [300, 250]);
    slotRemoveSize('content-oboxfluidmix', tabletSize, [300, 250]);
    slotRemoveSize('content-oboxfluidmix', mobileSize, [300, 250]);
    slotRemoveSize('content-oboxfluidmix', mobileSize, [320, 50]);
    slotSettings["content-oboxfluidmix"] = {
      "defaultSizes": ['fluid'],
      "mapping": [
        { "resolution": desktopSize, 'sizes': ['fluid'] },
        { "resolution": tabletSize, 'sizes': ['fluid'] },
        { "resolution": mobileSize, 'sizes': ['fluid'] }
      ]
    };


    slotRemoveSize('content-contentnative', desktopSize, [300, 250]);
    slotRemoveSize('content-contentnative', tabletSize, [300, 250]);
    slotRemoveSize('content-contentnative', mobileSize, [300, 250]);
    slotRemoveSize('content-contentnative', mobileSize, [320, 50]);
    slotSettings["content-contentnative"] = {
      "defaultSizes": ['fluid'],
      "mapping": [
        { "resolution": desktopSize, 'sizes': ['fluid'] },
        { "resolution": tabletSize, 'sizes': ['fluid'] },
        { "resolution": mobileSize, 'sizes': ['fluid'] }
      ]
    };


    if (OBOXADS.vars.adMode !== 'acq') {
      // disable 300x600 on mobile

      slotRemoveSize('content-1', false, [300, 600]);
      slotRemoveSize('content-1', mobileSize, [300, 600]);
    } //if


  });

  OBOXADS.fn.on('bannerConfigContext:content:native', function (e) {
    e.preventDefault = true;
  });

  let tracked = false;
  const trackEvent = function (category, action, label, value) {
    tracked = true;
    log('send', 'event', category, action, label);
    ga('send', 'event', category, action, label);
    //log('send', 'event', category, action, label);
    /*
    const e = encodeURIComponent;
    const xhr = new XMLHttpRequest();
    const urlParams = [
      "idsite=1", "rec=1", "apiv=1",
      "rand="+ Math.floor(Math.random() * 10000000),
      "e_c="+ e(category),
      "e_a="+ e(action),
      "e_n="+ e(label),
      "e_v="+ e(value)
    ].join('&');

    xhr.open('GET', `https://oboxlabs.com/analytics/piwik.php?${urlParams}`);
    xhr.send();
    */
  };


  OBOXADS.fn.on('slotRender', function (e) {
    if (tracked) {
      return;
    } //if

    if (OBOXADS.vars.adMode === 'acq') {
      const slotId = e.slot.getSlotElementId();
      const ssrtUtmDetails = sessionStorage.getItem('ssrt_utm_hollywoodpq.com');
      if (ssrtUtmDetails === null) {
        trackEvent('Ads', 'Missing UTM Details', `${slotId} - null`);
      } else {
        const ssrtUtmObj = JSON.parse(ssrtUtmDetails);
        if (!(ssrtUtmObj.hasOwnProperty('utm_campaign') && ssrtUtmObj.hasOwnProperty('utm_medium'))) {
          trackEvent('Ads', 'Missing UTM Details', `${slotId} - ${ssrtUtmDetails}`);
        } //if
      } //if

      const now = new Date();
      const year = now.getFullYear().toString();
      const month = (now.getMonth() < 9 ? "0" : "") + (now.getMonth() + 1)
      const day = (now.getDate() < 10 ? "0" : "") + now.getDate();
      const dateString = `${year}-${month}-${day}`;
      let ssrtPsDetails = sessionStorage.getItem(`ssrt_ps_v2_hollywoodpq.com_${dateString}`);
      if (ssrtPsDetails === null) {
        trackEvent('Ads', 'Missing PS Details', `${slotId} - null`);
      } else {
        const ssrtPsObj = JSON.parse(JSON.parse(ssrtPsDetails));
        if (!ssrtPsObj.hasOwnProperty('ps')) {
          trackEvent('Ads', 'Missing PS Details', `${slotId} - ${ssrtPsDetails}`);
        } //if
      } //if
    } //if
  });

  /*
    var nativeCount = 0;
    var nativeRR = false;
    var nativeContent = false;
    OBOXADS.fn.on('bannerConfigContext:side:native', function (e) {
      if (!nativeRR) {
        e.el.id = 'taboola-right-rail-thumbnails-'+ nativeCount++;
        e.el.style = "width: 300px; background: #fff; padding: 5px 3px;"
        _taboola.push({
          mode: 'thumbnails-rr3',
          container: e.el.id,
          placement: 'Right Rail Thumbnails ',
          target_type: 'mix'
        });
        nativeRR = true;
      } //if
      e.preventDefault = true;
    });

    OBOXADS.fn.on('bannerConfigContext:content:native', function (e) {
      if (!nativeContent) {
        e.el.id = 'taboola-below-article-thumbnails-'+ nativeCount++;
        _taboola.push({
          mode: 'thumbnails-c',
          container: e.el.id,
          placement: 'Below Article Thumbnails',
          target_type: 'mix'
        });
        nativeContent = true;
        e.preventDefault = true;
        return;
      } //if
      e.preventDefault =  OBOXADS.vars.adMode === "acq";
    });
    */

  OBOXADS.fn.on('bannerConfig:side', function (e) {
    var hide = !viewportLargerThan([992, 0]);
    if (hide) {
      e.preventDefault = true;
    } //if
  });

  OBOXADS.fn.on('bannerConfig', function (e) {
    var params = e.params;
    if (params.hasOwnProperty('context'))
      // setup first BB of gallery
      if (params.context === 'gallery-theater') {
        OBOXADS.vars.addons.gallery.banners.push(params.section + '-' + params.pos);
        // setup second BB of gallery (only if acq)
      } else if (params.section === 'content' && params.context === 'native') {
        if (e.el.parentNode.className.indexOf('obox-ad-side') !== -1) {
          if (OBOXADS.vars.adMode === "acq" && viewportLargerThan([0, 569])) {
            OBOXADS.vars.addons.gallery.banners.push(params.section + '-' + params.pos);
            e.preventDefault = false;
            e.stopPropagation = true;
          } else {
            e.preventDefault = true;
            e.stopPropagation = true;
          } //uf
        } //if
      } //if
  });

  OBOXADS.fn.on('initGallery', function (e) {
    if (OBOXADS.vars.adMode !== 'acq') {

      log('activating 2nd catfish');

      // hide 1st special to avoid having 2 catfish
      var specialAd = d.getElementById('oboxads-special-1');
      if (specialAd) {
        specialAd.style.display = 'none';
      } //if

      // insert speical add unit
      const body = document.getElementsByTagName('body')[0];
      OBOXADS.fn.appendTag(body, 'special');

    } //if
  });


  w._taboola = w._taboola || [];
  _taboola.push({ article: 'auto' });
  !function (e, f, u, i) {
    if (!document.getElementById(i)) {
      e.async = 1;
      e.src = u;
      e.id = i;
      f.parentNode.insertBefore(e, f);
    }
  }(document.createElement('script'),
    document.getElementsByTagName('script')[0],
    '//cdn.taboola.com/libtrc/oboxmedia-hollywoodpq/loader.js',
    'tb_loader_script');

  OBOXADS.fn.on('loaded', function () {
    /*// Adding Native tag 
    var contentEntry = document.querySelector(".entry-content");

    if (contentEntry !== null) {
      OBOXADS.fn.appendTag(contentEntry, 'content', { context: 'contentnative', insertAfter: true });
    }*/

    // Post Bottom Native block
    var postContentInner = document.querySelector(".entry-content");
    var bottomNativeBlock = null;

    if (postContentInner !== null) {

      var nativeType = (OBOXADS.vars.mobile) ? "mobile" : "desktop";

      var bottomNativeBlock = document.createElement("div");
      bottomNativeBlock.classList.add("clearfix", "native-bottom-block", nativeType);

      //
      var contentNative1 = document.createElement("div");
      contentNative1.classList.add("bottom-content-native", "left");
      var contentNative2 = document.createElement("div");
      contentNative2.classList.add("bottom-content-native");

      bottomNativeBlock.appendChild(contentNative1);
      bottomNativeBlock.appendChild(contentNative2);

      
      var recommendedContent = document.querySelector(".recommended-content");

      if(recommendedContent !== null)
      {
        recommendedContent.parentNode.insertBefore(bottomNativeBlock, recommendedContent, postContentInner);
      }
      else
      {
        postContentInner.parentNode.insertBefore(bottomNativeBlock, postContentInner.nextSibling);
      }

      // Insert ad tags
      OBOXADS.fn.appendTag(contentNative1, 'content', { context: 'contentnative' });
      OBOXADS.fn.appendTag(contentNative2, 'content', { context: 'contentnative' });
    }
    // EOF Post Bottom Native block

  });


  OBOXADS.fn.on('beforeInitTargeting', () => {
    if (OBOXADS.vars.adMode !== 'acq') {
      OBOXADS.vars.addons.staticAdsense.registerSlots([
        {
          slotName: 'header-2', slotId: '5375993149', sizes: [
            { resolution: desktopSize, size: [970, 90] },
            { resolution: tabletSize, size: [728, 90] },
            { resolution: mobileSize, size: [320, 250] }
          ]
        },
        {
          slotName: 'side-3', slotId: '8792779381', sizes: [
            { resolution: tabletSize, size: [300, 600] },
            { resolution: mobileSize, size: [300, 250] }
          ]
        },
       /* {
          slotName: 'content-4', slotId: '6166616040', sizes: [
            { resolution: mobileSize, size: [300, 250] }
          ]
        },*/
        {
          slotName: 'content-5', slotId: '6166616040', sizes: [
            { resolution: mobileSize, size: [300, 250] }
          ]
        },
        {
          slotName: 'footer-1', slotId: '3648688946', sizes: [
            { resolution: desktopSize, size: [970, 90] },
            { resolution: tabletSize, size: [728, 90] },
            { resolution: mobileSize, size: [320, 250] }
          ]
        }
      ]);
    } // if
  });

  (w.deployads = w.deployads || []).pageSegment = 'v3';
})();

/**
 * send bids to sortable before showing banners
 */
!function () {

  var deployads, timer,
    googletag = w.googletag;

  OBOXADS.vars.addons.sortable = OBOXADS.vars.addons.sortable || {};
  if (!OBOXADS.vars.addons.sortable.hasOwnProperty('enabled')) {
    OBOXADS.vars.addons.sortable.enabled = ! false ;
} //if

w['deployads'] = w['deployads'] || [];
deployads = w['deployads'];

const initSortable = function () {

  /**
   * Event fired when sortable library script file start to load
   *
   * @memberof OBOXADS
   * @event libLoad:sortable
   * @type {object}
   */
  OBOXADS.fn.emit('libLoad:sortable', {}, true);
  OBOXADS.fn.loadScript("//tags-cdn.deployads.com/a/hollywoodpq.com.js");

  // sortable provided init
  var a = window.googletag = window.googletag || {}; a.cmd = a.cmd || []; var c = window.deployads = window.deployads || [], g = setTimeout(function () { if (!c.apiReady) { c.apiTimeout = !0; c.gpt = { display: function (d) { a.cmd.push(function () { a.display(d) }) }, pubadsRefresh: function (d, b) { a.cmd.push(function () { a.pubads().refresh(d, b) }) }, pubadsDisplay: function (d, b, e, f) { a.cmd.push(function () { a.pubads().display(d, b, e, f) }) } }; for (var b = 0; b < c.length; b++)try { c[b]() } catch (d) { } } }, 2E3); c.push(function () { clearTimeout(g) });

};



OBOXADS.fn.on('beforeInitLoop', () => {
  const expId = sessionStorage.getItem('oboxads-exp-id');
  const deployads = window.deployads
  if (!deployads.hasOwnProperty('pageSegment') || deployads.pageSegment === '') {
    deployads.pageSegment = expId;
  } // if
})

OBOXADS.vars.addons.sortable.init = initSortable;

if (OBOXADS.vars.addons.sortable.enabled) {

  OBOXADS.fn.on('libLoad:gpt', function () {
    // needs to be enabled in custom when sortableTesting os set
    initSortable();
  });

  OBOXADS.fn.on('libInit:gpt', function () {

    deployads.push(function () {
      /**
       * Event fired when sortable library is initializing
       *
       * note that gpt services might not be enabled yet 
       *
       * @memberof OBOXADS
       * @event libInit:sortable
       * @type {object}
       */
      OBOXADS.fn.emit('libInit:sortable', {}, true);

      deployads.gpt.pubadsDisableInitialLoad();

      deployads.gpt.enableServices();

      /**
       * Event fired when sortable library is loaded and initialized
       *
       * @memberof OBOXADS
       * @event libReady:sortable
       * @type {object}
       */
      OBOXADS.fn.emit('libReady:sortable', {}, true);
    });

  });


} //if

// track virtual page views in sortable
OBOXADS.fn.on('pageView', function (e) {
  if (OBOXADS.vars.addons.sortable.enabled) {
    deployads.push(function () { deployads.newPage() });
  } //if
});

OBOXADS.fn.on('slotDisplay', function (e) {
  if (OBOXADS.vars.addons.sortable.enabled) {
    deployads.push(function () {
      deployads.gpt.display(`oboxads-${e.slotName}`);
    });
  } else {
    googletag.cmd.push(function () {
      googletag.pubads().refresh(e.slotsToShow, e.options);
    });
  }
});

const sendBanners = (e) => {
  if (OBOXADS.vars.addons.sortable.enabled) {
    deployads.push(function () {
      deployads.gpt.pubadsRefresh(e.slotsToShow, e.options);
    });
  } else {
    googletag.cmd.push(function () {
      googletag.pubads().refresh(e.slotsToShow, e.options);
    });
  }
};

OBOXADS.fn.on('bannerShow', sendBanners);
OBOXADS.fn.on('bannerRefresh', sendBanners);

}();

!function () {

    
    var wrapper, el, loaded = false;
    OBOXADS.fn.on('initGallery',function (e) {
      var gallery = e.gallery;
      
      /* since there is no load event
       * we use imageLoadComplete to create the 
       * native elements and styles */
      gallery.listen('imageLoadComplete', function() {
        
        if (wrapper === undefined) {
         // log('OBOXADS ', 'adding wrapper');

          /* add needed styles */
          addCSS([
            '.oboxads-native-gallery-wrapper {',
            '  position: relative;',
            '  top: 0;', 
            '  left: 5%;',
            '  width: 90%;',
            '  height: 100%;',
            '  z-index: 10000;',
            '  background: #fff;',
            '}',

            '.oboxads-native-gallery-wrapper .oboxads-native {',
            '  width: 60%;',
            '  height: 50%;',
            '  min-height: 400px;',
            '  margin: 92px auto 0 auto; ',
            '  z-index: 99999;',
            '}',

            '@media (max-width: 767px) {',
            '  .oboxads-native-gallery-wrapper {',
            '    left: 15%;',
            '    width: 70%;',
            '  }',

            '  .oboxads-native-gallery-wrapper .oboxads-native {',
            '    width: 90%;',
            '    height: 75%;',
            '    min-height: 400px;',
            '    margin: 92px auto 0 auto; ',
            '}',
            '}'
          ].join("\n"));

          /* Create an extra image that will show native */
          gallery.items.push({
            src: OBOXADS.vars.baseURL + '/assets/blank.gif',
            w: 1,
            h: 1
          });

          // insert wrapper and placeholder element 
          wrapper = d.createElement('DIV');
          wrapper.className = 'oboxads-native-gallery-wrapper';
          wrapper.style = 'display: none;';

          el = d.createElement('DIV');
          el.className = 'oboxads-native';
          el.id = "oboxads-native-"+ new Date().getTime();
          wrapper.appendChild(el);

          // add wrapper to page
          gallery.container.parentNode.appendChild(wrapper);
        }
      });

      /* Check if we are on last slide if so load native into wrapper */
      gallery.listen('beforeChange', function() {
        var currentIndex = gallery.getCurrentIndex() + 1,
            galleryCount = gallery.options.getNumItemsFn();
        
        //log('OBOXADS '+ currentIndex +' of '+ galleryCount);
        if (wrapper && el) {
          if (currentIndex === galleryCount) {

            wrapper.style.display = 'block';

            if (!loaded) {
              loaded = true;
              _taboola.push({
                mode: 'thumbnails-c',
                container: el.id,
                placement: 'Above Gallery Thumbnails',
                target_type: 'mix'
              });
            } //if

            //log('OBOXADS', 'showing wrapper');
          } else {
            wrapper.style.display = 'none';
          } //if
        } //if
      });
    });
}();

!function () {
  OBOXADS.vars.addons.videoPlayer = {};
  /*
      var scriptsLoaded = false;
  function loadScripts(callback) {
     if (scriptsLoaded) {
       callback();
       return;
    }
    //load scripts ...
  }*/
  
  OBOXADS.fn.on('initVideoPlayer', function (e, adUnit) {

    const videojs = "https://cdnjs.cloudflare.com/ajax/libs/video.js/7.1.0/video.min.js";
    const ads = "https://cdnjs.cloudflare.com/ajax/libs/videojs-contrib-ads/6.4.1/videojs.ads.js";
    const ima = 'https://cdnjs.cloudflare.com/ajax/libs/videojs-ima/1.5.1/videojs.ima.js';
    const googleima = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
    const defaultOptions = {
      domain: 'obox'
    };
    const options = Object.assign(defaultOptions, e.opts);

    if (typeof requirejs === "undefined" && typeof require === "undefined") {
      
      OBOXADS.fn.loadScript(videojs, function () {
        OBOXADS.fn.loadScript(googleima, function () {
          OBOXADS.fn.loadScript(ads, function () {
            OBOXADS.fn.loadScript(ima, function () {
          
                var xhr = [];

                for (var i = 0; i < e.videoPlayer.length; i++) {
                  (function(i){
                    xhr[i] = new XMLHttpRequest();
                    xhr[i].open('GET', 'https://api.oboxmedia.com/v1/video-player/videoId/'+e.videoPlayer[i].videoId+'?domain='+options.domain);
                    //xhr[i].open('GET', 'https://api.oboxmedia.com/v1/video-player/videoId/240846536');
                    xhr[i].onreadystatechange = function() {
                        if (xhr[i].readyState === 4 && xhr[i].status === 200){
                          e.content = JSON.parse(xhr[i].responseText);
                          executeVimeo(e,i, adUnit);
                        } else {
                          log('Obox Video Player: Request to Obox API failed.  Returned status of ' + xhr.status);
                        }
                      };
                      xhr[i].setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                      xhr[i].send();
                    })(i);
                  }
              });
            });
          });
        }); 
    } else {
      
      log('Obox Video Player: RequireJS Detected.');

      // Temporary fix: try/catch is needed for bypassing a requireJS error on NewBOX sites.
      try {
        var MyRequire = requirejs.config({
          waitSeconds: 15,
          map: {
            '*': {
              "video.js": "videojs",
            }
          },
          paths: {
            "videojs": "https://cdnjs.cloudflare.com/ajax/libs/video.js/7.1.0/video.min",
            "ads": "https://cdnjs.cloudflare.com/ajax/libs/videojs-contrib-ads/6.4.1/videojs.ads",
            'ima': 'https://cdnjs.cloudflare.com/ajax/libs/videojs-ima/1.5.1/videojs.ima',
            'googleima': 'http://imasdk.googleapis.com/js/sdkloader/ima3',
          },
          shim: {
            'ima': {
              deps: ['googleima', 'ads']
            },
            'ads': {
              deps: ['videojs-in-global']
            }
          }
        });

        define("videojs-in-global", ['videojs'], function(videojs) {
          window.videojs = videojs;
        }); 

        MyRequire(["ima"], function(ima) {
          var xhr = [];
          for (var i = 0; i < e.videoPlayer.length; i++) {
            (function(i){
              xhr[i] = new XMLHttpRequest();
              xhr[i].open('GET', 'https://api.oboxmedia.com/v1/video-player/videoId/'+e.videoPlayer[i].videoId);
              xhr[i].onreadystatechange = function(){
                  if (xhr[i].readyState === 4 && xhr[i].status === 200){
                    e.content = JSON.parse(xhr[i].responseText);
                    executeVimeo(e,i, adUnit);
                } else {
                  log('Obox Video Player: Request to Obox API failed.  Returned status of ' + xhr.status);
                }
              };
              xhr[i].setRequestHeader('X-Requested-With', 'XMLHttpRequest');
              xhr[i].send();
            })(i);
          } // for
        });
      
      } catch (err) {
        var MyRequire = requirejs.config({
          waitSeconds: 15,
          map: {
            '*': {
              "video.js": "videojs",
            }
          },
          paths: {
            "videojs": "https://cdnjs.cloudflare.com/ajax/libs/video.js/7.1.0/video.min",
            "ads": "https://cdnjs.cloudflare.com/ajax/libs/videojs-contrib-ads/6.4.1/videojs.ads",
            'ima': 'https://cdnjs.cloudflare.com/ajax/libs/videojs-ima/1.5.1/videojs.ima',
            'googleima': 'http://imasdk.googleapis.com/js/sdkloader/ima3',
          },
          shim: {
            'ima': {
              deps: ['googleima', 'ads']
            },
            'ads': {
              deps: ['videojs-in-global']
            }
          }
        });

        define("videojs-in-global", ['videojs'], function(videojs) {
          window.videojs = videojs;
        }); 

        MyRequire(["ima"], function(ima) {
          var xhr = [];
          for (var i = 0; i < e.videoPlayer.length; i++) {
            (function(i){
              xhr[i] = new XMLHttpRequest();
              xhr[i].open('GET', 'https://api.oboxmedia.com/v1/video-player/videoId/'+e.videoPlayer[i].videoId);
              xhr[i].onreadystatechange = function(){
                  if (xhr[i].readyState === 4 && xhr[i].status === 200){
                    e.content = JSON.parse(xhr[i].responseText);
                    executeVimeo(e,i, adUnit);
                } else {
                  log('Obox Video Player: Request to Obox API failed.  Returned status of ' + xhr.status);
                }
              };
              xhr[i].setRequestHeader('X-Requested-With', 'XMLHttpRequest');
              xhr[i].send();
            })(i);
          } // for
        });
     
      }
    }
  });
  
  const executeVimeo = function(e,i, adUnit) {
    
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i)) {
      var videoContentSRC = e.content.files[1].link;
      var videoContentType = "video/mp4";
      var videoPoster = e.content.pictures.sizes[3].link;
    } else {
      var videoContentSRC = e.content.files[0].link;
      var videoContentType = "video/mp4";
      var videoPoster = e.content.pictures.sizes[5].link;
    }

    if (videoPoster == null || videoPoster == undefined) {
      videoPoster = '';
    }

    var videoPlayerContainer = [
      '<style type="text/css">', 
        '@import url("//cdn.oboxads.com/v3/addons/videoPlayer/obox_videoPlayer.css");', 
      '</style>', 
      '<video style="position: absolute; top:0; left:0; height:100%; width: 100%" id="content_video_' +i+'" playsinline="true" class="video-js vjs-default-skin vjs-fill vjs-big-play-centered"', 
      'poster="' + videoPoster + '"', 
      'controls preload="auto">', 
      '<source src="' + videoContentSRC + '" type="' + videoContentType + '" />', 
      '</video>'].join("\n");
    
    var contentContainer = document.querySelector('.'+e.videoPlayer[i].parentClassName);
    var originalVideoContainer = contentContainer.querySelector('iframe');

    originalVideoContainer.remove();
   
    log('Obox Video Player: Inserting Video Container');
    contentContainer.insertAdjacentHTML('beforeend', videoPlayerContainer);
    contentContainer.style.paddingTop = '0';

    addCSS([
      'div.'+e.videoPlayer[i].parentClassName+' {',
      '  display: block;',
      '}'
    ].join("\n"));

    if (OBOXADS.vars.custom !== undefined) {
      e.adUnit += '&cust_params=&cust_params=custom%3D' + OBOXADS.vars.custom;
    }

    var player = videojs('content_video_'+i, {resizeManager: false });
    var options = {
      id: 'content_video_'+i,
      //Google adTagUrl Sample: "http://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/ad_rule_samples&ciu_szs=300x250&ad_rule=1&impl=s&gdfp_req=1&env=vp&output=xml_vmap1&unviewed_position_start=1&cust_params=sample_ar%3Dpremidpostpod%26deployment%3Dgmf-js&cmsid=496&vid=short_onecue&correlator=" + randNumber,
      adsManagerLoadedCallback: onAdsManagerLoaded,
      adTagUrl: e.adUnit,
      nativeControlsForTouch: false,
      prerollTimeout: 1000,
      disableCustomPlaybackForIOS10Plus: true,
      vpaidMode: google.ima.ImaSdkSettings.VpaidMode.INSECURE
    };

    player.ima(options);

    var contentPlayer = document.getElementById('content_video_'+i);
    if ((navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i)) && contentPlayer.hasAttribute('controls')) {
      contentPlayer.removeAttribute('controls');
    }

    if (navigator.userAgent.match(/iPhone/i) && contentPlayer.hasAttribute('controls')) {
      log('Obox Video Player: This is an iPhone match');
      contentPlayer.removeAttribute('controls');
    }

    // Initialize the ad container when the video player is clicked, but only the
    // first time it's clicked.
    var startEvent = 'click';
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i)) {
      startEvent = 'touchend';
    }

    function onAdEvent(adEvent) {
      // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
      // don't have ad object associated.
      var ad = adEvent.getAd();
      var adData = adEvent.getAdData();

      switch (adEvent.type) {
        case google.ima.AdEvent.Type.CLICK:
          break;
        case google.ima.AdEvent.Type.COMPLETE:
          break;

      }
    }

    function onAdsManagerLoaded(adsManagerLoadedEvent) {

      // Add listeners to the required events.
      player.ima.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, onAdError);
      player.ima.addEventListener(google.ima.AdEvent.Type.COMPLETE, onAdComplete);
      player.ima.addEventListener(google.ima.AdEvent.Type.CLICK, onAdEvent);
      player.ima.addEventListener(google.ima.AdEvent.Type.LOADED, onAdLoaded);
    }

    function onAdError(adErrorEvent) {
      log('Obox Video Player: Error Triggered: ' + adErrorEvent.getError());
      //player.ima.destroy();
    }

    function onAdComplete(onAdCompleteEvent) {
      log('Obox Video Player: Ad Complete Event');
      //document.getElementById('ima-ad-container').style.visibility = 'hidden';
      // completed pixel
    }

    function onAdLoaded(onAdLoaded) {
      log('Obox Video Player: Ad is Loaded');
    }

    player.one(startEvent, function () {
      log('Obox Video Player: Initializing Ad Display Container');
      player.ima.initializeAdDisplayContainer();
      player.ima.requestAds();
      //player.enterFullWindow();
    });
  };

}();
!function () {
  OBOXADS.vars.addons.outstream = OBOXADS.vars.addons.outstream || {};
  let outstream = OBOXADS.vars.addons.outstream;
  outstream.showAds = true;

  OBOXADS.fn.on('loaded', () => {
    if (outstream.showAds) {
    /**
     * Event fired before we load outstream
     *
     * @memberof OBOXADS
     * @event beforeOutstreamLoad
     * @type {object}
     */
     const eventObj = {}
      OBOXADS.fn.emit('beforeOutstreamLoad', eventObj)
      if (!eventObj.preventDefault) {
        OBOXADS.fn.loadScript("//static.freeskreen.com/publisher/816/freeskreen.min.js");
      } //if
    } //if
  });
}();

!function () {
  OBOXADS.vars.addons.inImage = OBOXADS.vars.addons.inImage || {};
  let inImage = OBOXADS.vars.addons.inImage;

  inImage.showAds = true;
  //OBOXADS.fn.on('passback:oboxoop', () => {

    //console.log("Receive message form oop callback");
  OBOXADS.fn.on('loaded', () => {
    
    var isImpact = false;
    if(typeof OBOXADS.vars.custom !== "undefined" && OBOXADS.vars.custom.toLowerCase().indexOf("high-impact") !== -1)
      isImpact = true

    if (inImage.showAds && !isImpact) {
      w['ggv2id'] = '6a2aea8c';
      OBOXADS.fn.loadScript("//g2.gumgum.com/javascripts/ggv2.js")
    } //if
  });
 // });

    
  if(true)
  {
    OBOXADS.fn.on('passback:gumgum', (e) => {
      console.log("Received message from passback");
      log('activating 1st catfish');
      // insert speical add unit
      const body = document.getElementsByTagName('body')[0];
      OBOXADS.fn.appendTag(body, 'special');

      /*
       |-----------------------------
       | Remove conflicting div inserted by gumgum
       |-----------------------------
       */
      const nodeList = Array.prototype.slice.call(document.querySelectorAll('[id^="ad_is_"'))
      const idPattern = /^ad_is_\d*$/

      nodeList.forEach((el) => {
        if (idPattern.exec(el.id)) {
          el.style.display = 'none'
        } // if
      })
      /* |---- End of div removal ----| */
    });
  }

}();

!function () {

  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
        document,'script','https://connect.facebook.net/en_US/fbevents.js');

  OBOXADS.fn.emit('pixelReady', {}, true);

  fbq('init', '1400605243389409');
  fbq('track', 'PageView');

}();


    start();

    /*
    try {
        log('(timming) took '+ (oboxStartTime - _startTime) +'ms from <head> to load of tagman');
    } catch (e) { }

    log('(timming) took '+ (new Date().getTime() - oboxStartTime) +'ms to init tagman');
    */
})(window, document);
